// Chat.js
import React, { useState, useEffect, useRef, useCallback } from "react";
import { CircularProgressbarWithChildren } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import axios from "axios";
import { Icon } from "@iconify/react";
// import { ChatBot } from "./ChatBot";
import { Col, Row, Modal, Button, Image, Form, Tooltip, OverlayTrigger } from "react-bootstrap";
import { Typewriter } from "react-simple-typewriter";
import { Link, useNavigate } from "react-router-dom";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";
import "./ChatBot.css";
import { toast } from "react-hot-toast";
import Select from "react-select";
import parse from "html-react-parser";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { WindupChildren } from "windups";
import Slider from "rc-slider";
import { useLocation } from "react-router-dom";
import { getStorage } from "firebase/storage";
import { getFirestore, setDoc } from "@firebase/firestore";
import { doc, collection, getDocs, getDoc } from 'firebase/firestore';
import firebase from 'firebase/compat/app';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { v4 as uuidv4 } from 'uuid';
import { SSE } from "sse";
import { getFirestoreInstance } from "../../Utils/Utils";
import { styled } from '@mui/material/styles';

import {
  ref,
  uploadBytesResumable,
  getDownloadURL
} from "firebase/storage";
import { initializeApp } from "firebase/app";
import ImageSlider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { themeSelector } from "../../Redux/Slices/themeSlice";
import { useSelector } from "react-redux";
import useAutosizeTextArea from "../../Utils/useAutosizeTextArea";
import Hls from 'hls.js';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { useParams } from 'react-router-dom';

const LordIcon = ({ src, trigger, style }) => {
  useEffect(() => {
    // Check if the script is already loaded
    const scriptAlreadyAdded = document.querySelector('script[src="https://cdn.lordicon.com/lordicon-1.2.0.js"]');

    const script = document.createElement('script');
    script.src = 'https://cdn.lordicon.com/lordicon-1.2.0.js';
    script.async = true;

    if (!scriptAlreadyAdded)
    {
      document.body.appendChild(script);
    }

    return () => {
      if (!scriptAlreadyAdded)
      {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <lord-icon
      src={src}
      trigger={trigger}
      colors="primary:#ffffff,secondary:#08a88a"
      stroke="bold"
      style={style}
    ></lord-icon>
  );
};




const customStyles2 = {
  menu: (provided, state) => ({
    ...provided,
    backgroundColor: '#333',  // Change this to your desired color
  }),
  menuPortal: base => ({ ...base, zIndex: 9993 })
};

const customStyles = {
  menu: (provided, state) => ({
    ...provided,
    backgroundColor: '#333',  // Change this to your desired color
  }),
  menuPortal: base => ({ ...base, zIndex: 9999 })
};

var numSentence = 0;
var isResponseWaiting = false;

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === 'light' ? '#36e899' : '#36e899',
  },
}));

function ChatBot(props) {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const [chatHistory, setChatHistory] = useState([]);
  const [isTyping, setIsTyping] = useState(false);
  const [currentMessage, setCurrentMessage] = useState("");
  const [textareaHeight, setTextareaHeight] = useState(50);
  const [avatarVideoUrl, setavatarVideoUrl] = useState("");
  const audioRef = useRef("");
  const [isLoading, setIsLoading] = useState(false);

  const [isProgressing, setIsProgressing] = useState(false);

  const [totalDocs, setTotalDocs] = useState(0);

  const navigate = useNavigate();

  const chatFieldRef = useRef(null);

  // Function to scroll to the bottom
  const scrollToBottom = () => {
    const chatField = chatFieldRef.current;
    if (chatField)
    {
      chatField.scrollTop = chatField.scrollHeight;
    }
  };

  const [show2, setShow2] = useState(false);
  const [isOutputted, setisOutputted] = useState(true);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');

  const [isPlaying, setIsPlaying] = useState(false);
  const [isPlayingImage, setIsPlayingImage] = useState(false);

  const [premiumVoices, setIsPremiumVoices] = useState({})
  const [speechGenData, setSpeechGenData] = useState({});

  const [yawScale, setYaw] = useState(0);
  const [headMovement, setHeadMovement] = useState(4);
  const [pitchScale, setPitchScale] = useState(0);
  const [rollScale, setRollScale] = useState(0);
  const [inputPrompt, setInputPrompt] = useState('');
  const [isUploading, setIsUploading] = useState(false);
  const [isLanguageModal, setIsLanguageModal] = useState(false);
  const [isVoiceModal, setIsVoiceModal] = useState(false);
  const [isChatModal, setIsChatModal] = useState(false);

  const [chatbotName, setChatbotName] = useState("");
  const [descriptionChatbot, setDescriptionChatbot] = useState("");
  const [createdBy, setIsCreated] = useState("");



  const [isCreating, setIsCreating] = useState(false);
  const isThemeDark = useSelector(themeSelector);
  // console.log({ isThemeDark })
  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);

  const handleCloseLanguageModal = () => setIsLanguageModal(false)
  const handleCloseVoiceModal = () => setIsVoiceModal(false)
  const handleCloseChatModal = () => setIsChatModal(false)

  const [videoTimerId, setVideoTimerId] = useState(null);

  function getRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  const [progress, setProgress] = useState(0);


  const { username } = useParams();
  useEffect(() => {
    const fetchUserData = async () => {
      const docRef = doc(db, "ChatBots", username); // Adjust collection name and document ID as needed
      const docSnap = await getDoc(docRef);

      if (docSnap.exists())
      {
        const userData = docSnap.data();
        console.log("CHATBOT DATA2");
        console.log(userData);

        setHasGenerating(true);
        setIsVideo(true);

        setActiveImage(userData.cover_image);
        setGeneratedImages([userData.inputImage]);
        setIsRegenerated(true)
        setInputPrompt(userData.inputPrompt);


        var idleAnimList = userData.generated_hello_video.split('/');
        var idleAnim = idleAnimList[idleAnimList.length - 1];
        setIdleAnimation(idleAnim);
        setUrl(`${userData.generated_hello_video}?backup=${idleAnim}`);
        setUrl2(`${userData.generated_intro_vid}?backup=${idleAnim}`);

        setSelectedVoiceForSelectBox(userData.voice);
        setSelectedValue(userData.voice.value);

        setChatbotName(userData.name);
        setIsCreated(userData.created_by);
        setDescriptionChatbot(userData.description);

        // const video = videoRef2.current;
        // let hls = playVideo(video, url, true);  // Load and play the first video



        // setImageUrl(userData.imageUrl); // Assuming 'imageUrl' is the field name in your Firestore document
      } else
      {
        console.log("No such document!");
      }
    };
    console.log("CHATBOT DATA1");
    fetchUserData();
  }, [username]);

  // const startProgress = () => {
  //   setisOutputted(false);
  //   setProgress(0);

  //   const interval = setInterval(() => {
  //     setProgress(prevProgress => (prevProgress < 100 ? prevProgress + 1 : 100));
  //   }, 100);

  //   setTimeout(() => {
  //     clearInterval(interval);
  //     setisOutputted(true);
  //     // setProgress(0);
  //   }, 10000);
  // };

  const callEndpoint = async () => {
    try
    {
      const response = await fetch('https://xq3pl2oc187t2f-5000.proxy.runpod.net/sessions/get_vid', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          "sessionuid": sessionuid,
          'numGenerated': numGenerated
        }),
      });

      // Handle the response if necessary...
      const data = await response.json();

    } catch (error)
    {
      console.error('Failed to fetch data:', error);
    }
  };

  const startVideoTimer = () => {
    if (videoTimerId)
    {
      // A timer is already running, do not start another.
      return;
    }

    const id = setInterval(callEndpoint, 1000); // Call every 5 seconds
    setVideoTimerId(id);
  };

  const stopVideoTimer = () => {
    if (videoTimerId)
    {
      clearInterval(videoTimerId);
      setVideoTimerId(null);
    }
  };

  // new streaming values
  const [isIntroLoading, setIsIntroLoading] = useState(false);
  const [url, setUrl] = useState("");
  const [url2, setUrl2] = useState("");
  const [idleAnimationDefault, setIdleAnimation] = useState("");
  const [sessionuid, setSessionUid] = useState('');
  const [isRunning, setIsRunning] = useState(false);
  const [coverImage, setCoverImage] = useState('');

  const [userPlayed, setIsUserPlayed] = useState(false);

  const [visible, setVisible] = useState(true);

  useEffect(() => {
    // setShow2(true);
    const timer3 = setTimeout(() => {
      // setVisible(false);
    }, 2000);  // Set a timer to hide overlay after 2 seconds

    return () => clearTimeout(timer3);  // Clear timer on component unmount
  }, []);  // Empty dependency array means this useEffect runs once, similar to componentDidMount

  const [countDown2, setCountDown2] = useState(0);

  useEffect(() => {
    let intervalId;

    intervalId = setInterval(() => {
      setCountDown2(prevCount => Math.min(prevCount + 1, 100));  // Increment by 2
    }, 200);

    const speedUpTimer = setTimeout(() => {
      clearInterval(intervalId);  // Clear the initial slow interval

      // Start a faster interval of 50ms after the first second
      intervalId = setInterval(() => {
        setCountDown2(prevCount => Math.min(prevCount + 10, 100));  // Increment by 10
      }, 180);
    }, 400);

    const timer2 = setTimeout(() => {
      // setVisible(false);
      setCountDown2(100);
      clearInterval(intervalId);  // Clear the interval when hiding the overlay
    }, 2000);

    return () => {
      clearTimeout(timer2);
      clearInterval(intervalId);  // Clear the interval on component unmount
    };
  }, []);

  useEffect(() => {
    const sessionId = uuidv4();  // Generate a unique session ID
    setSessionUid(sessionId);
    try
    {
      fetch('https://xq3pl2oc187t2f-5000.proxy.runpod.net/sessions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          key: sessionId,
          value: {
            'videos': []
          },
        }),
      });


    } catch (error)
    {
      console.error('Error:', error);
    }
  }, []);

  function splitEveryFourWords(text) {
    let words = text.split(' ');
    let result = [];

    for (let i = 0; i < words.length; i += 6)
    {
      result.push(words.slice(i, i + 6).join(' ') + '.');
    }

    return result.join(' ');
  }

  function endsWithNumber(str) {
    const lastChar = str.slice(-1);
    return !isNaN(lastChar) && lastChar !== ' ';
  }

  const videoRef2 = useRef(null);
  const videoRef3 = useRef(null);

  var numGenerated = 0;
  var hasGeneratedSequence = false;
  const [intervalId, setIntervalId] = useState(null);
  var idleAnimation = "https://xq3pl2oc187t2f-5000.proxy.runpod.net/hls/3s.m3u8";

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    // Set up the event listener for window resize
    window.addEventListener('resize', handleResize);

    // Clean up the event listener
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const playVideo = (video, url, autoplay = true) => {
    try
    {
      if (Hls.isSupported())
      {
        const hls = new Hls();
        hls.loadSource(url);
        hls.attachMedia(video);
        if (autoplay)
        {
          hls.on(Hls.Events.MANIFEST_PARSED, () => {
            video.play().then(() => {
              setVisible(false);
            }).catch(e => {
              console.log("error occured");
              setVisible(true);
            });
          });
        }
        return hls;  // Return the hls instance for cleanup
      } else if (video.canPlayType('application/vnd.apple.mpegurl'))
      {
        video.src = url;
        if (autoplay)
        {
          video.addEventListener('loadedmetadata', () => {
            video.play();
          });
        }
      }
    } catch (e)
    {
      // setVisible(true);
      // print('fewfe')
      console.error(e);
    }
  };

  useEffect(() => {
    if (sessionuid !== '')
    {
      console.log('sessionUid:', sessionuid);
    }
  }, [sessionuid]);

  useEffect(() => {
    // console.log()
  })

  const handlePlayVideo = () => {
    if (videoRef.current)
    {
      videoRef.current.play();
    }
    setVisible(false); // Or any other state change you need
    setIsUserPlayed(true);
  };

  useEffect(() => {
    // const video = videoRef2.current;
    // let hls = playVideo(video, url, false);  // Load and play the first video
    if (sessionuid !== '' && url !== '')
    {
      setTimeout(() => {

        const video = videoRef2.current;
        const video2 = videoRef3.current;

        idleAnimation = url;

        if (!video || !video2)
        {
          console.error('Video is null');
          return;
        }

        video.style.display = 'block';  // Show video1
        video2.style.display = 'none';  // Hide video2

        let hls = playVideo(video, url);  // Load and play the first video
        let hls2 = playVideo(video2, url2, false);  // Preload the second video without playing

        // setVisible(false);

        const handleVideo1Ended = async () => {

          setIsVideo1(false);
          idleAnimation = url2;

          if (numSentence == numGenerated && hasGeneratedSequence)
          {
            numGenerated = 0;
            numSentence = 0;
            hasGeneratedSequence = false;
            setIsLoading(false);
            setisOutputted(true);
          }


          var tmp_url = idleAnimation;

          video.style.display = 'none';  // Hide video1
          video2.style.display = 'block';  // Show video2

          if (hls)
          {
            hls.destroy();  // Optionally destroy the hls instance for video1
          }

          try
          {
            const response = await fetch('https://xq3pl2oc187t2f-5000.proxy.runpod.net/sessions/get_vid', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                "sessionuid": sessionuid,
                'numGenerated': numGenerated
              }),
            });

            // const response = await fetch(`https://i5z2sbz6n8ylzb-5000.proxy.runpod.net/sessions/${sessionuid}/videos/has_videos`);
            const data = await response.json();
            if (data['total_vids'] > 0)
            {

              // setNumGenerated(numGenerated + 1);
              numGenerated += 1;
              hasGeneratedSequence = true;
              tmp_url = `${data['video']}?backup=${idleAnimationDefault}`;


              hls2 = playVideo(video2, tmp_url, false);
              hls = playVideo(video, idleAnimation, false);
              setIsProgressing(false);

              video2.play();  // Play the preloaded second video

            } else
            {
              tmp_url = idleAnimation;
              hls = playVideo(video, tmp_url, false);

              video2.play();  // Play the preloaded second video
            }
          } catch (error)
          {
            console.error('Error:', error);
          }



        };


        const handleVideo2Ended = async () => {
          // if (hls)
          // {
          //   hls.destroy();  // Optionally destroy the hls instance for video1
          // }
          setIsVideo1(true);

          if (numSentence == numGenerated && hasGeneratedSequence)
          {
            numGenerated = 0;
            numSentence = 0;
            hasGeneratedSequence = false;
            setIsLoading(false);
            setisOutputted(true);
          }


          var tmp_url = idleAnimation;

          video.style.display = 'block';  // Hide video1
          video2.style.display = 'none';  // Show video2

          if (hls2)
          {
            hls2.destroy();  // Optionally destroy the hls instance for video1
          }

          try
          {
            const response = await fetch('https://xq3pl2oc187t2f-5000.proxy.runpod.net/sessions/get_vid', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                "sessionuid": sessionuid,
                'numGenerated': numGenerated
              }),
            });

            // const response = await fetch(`https://i5z2sbz6n8ylzb-5000.proxy.runpod.net/sessions/${sessionuid}/videos/has_videos`);
            const data = await response.json();
            if (data['total_vids'] > 0)
            {
              // if (isResponseWaiting)
              // {
              //   console.log('showing response on UI');
              // setIsTyping(false);
              // setChatHistory([
              //   ...newChatHistory,
              //   {
              //     text: resultRef.current,
              //     sender: "system",
              //     profile: activeImage, //
              //     audioUrl: "", //
              //     // videoUrl: '',
              //   },
              // ]);
              //   isResponseWaiting = false;
              // }
              numGenerated += 1;
              hasGeneratedSequence = true;
              tmp_url = `${data['video']}?backup=${idleAnimationDefault}`;
              // hls2 = playVideo(video2, urls[0], false);
              hls = playVideo(video, tmp_url, false);
              hls2 = playVideo(video2, idleAnimation, false);
              setIsProgressing(false);

              video.play();  // Play the preloaded second video

            } else
            {
              tmp_url = idleAnimation;
              // hls2 = playVideo(video2, urls[0], false);
              hls2 = playVideo(video2, tmp_url, false);

              video.play();  // Play the preloaded second video
            }
          } catch (error)
          {
            console.error('Error:', error);
          }


          // urlIndexRef.current = 1 - urlIndexRef.current;  // Toggle the URL index
          // hls2 = playVideo(video2, urls[urlIndexRef.current], false);  // Update the source for video1


        };

        console.log('Attaching event listener');
        video.addEventListener('ended', handleVideo1Ended);
        video2.addEventListener('ended', handleVideo2Ended);

        return () => {
          video.removeEventListener('ended', handleVideo1Ended);
          if (hls2)
          {
            hls2.destroy();  // Cleanup for the second video
          }
          // ... other cleanup ...
        };
      }, 0);
    }
  }, [sessionuid, url, url2, idleAnimationDefault, userPlayed]);

  // }, [url]);  // re-run this useEffect block whenever 'src' prop changes

  const deleteSession = async () => {
    if (!sessionuid)
    {
      console.error('Session ID is required');
      return;
    }

    try
    {
      const response = await fetch(`https://xq3pl2oc187t2f-5000.proxy.runpod.net/sessions/${sessionuid}`, {
        method: 'DELETE',
      });

      if (response.ok)
      {
        console.log('Session deleted successfully');
      } else
      {
        console.error('Failed to delete session:', response.statusText);
      }
    } catch (error)
    {
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    // Cleanup function to clear the timer when the component unmounts
    return () => {
      if (intervalId)
      {
        deleteSession();
        clearInterval(intervalId);
      }
    }
  }, [intervalId]);


  const handleClick = () => {
    setShow(prevValue => !prevValue); // This toggles the boolean value
  };





  const imageUrls = [
    "https://firebasestorage.googleapis.com/v0/b/orbofibluesky-7f04d.appspot.com/o/danny_generations%2Fphoto_2023-09-28_15-46-20.jpg?alt=media&token=de616bb0-74ba-41b5-bfe4-5a3fb1795b9c&_gl=1*p1tjg6*_ga*NTA5MjA0MjA0LjE2NzM0MDg0ODI.*_ga_CW55HF8NVT*MTY5NTkzMDMwMy44Ny4xLjE2OTU5MzExNjMuMjkuMC4w",
    "https://storage.googleapis.com/generativeartbucket1/eezyl/20231004-025022/20231004-025022-2.webp",
    "https://firebasestorage.googleapis.com/v0/b/orbofibluesky-7f04d.appspot.com/o/photo_2023-10-04_09-53-57%20(2).jpg?alt=media&token=999fe359-f0c3-43c0-a448-8b79e41f8a98&_gl=1*1dh2d3f*_ga*NTA5MjA0MjA0LjE2NzM0MDg0ODI.*_ga_CW55HF8NVT*MTY5NjUyMDU0OC44NS4xLjE2OTY1MjA2NDUuNjAuMC4w",
    "https://firebasestorage.googleapis.com/v0/b/orbofibluesky-7f04d.appspot.com/o/danny_generations%2Fphoto_2023-09-28_15-45-31.jpg?alt=media&token=54471489-4e51-4828-8576-093d818a9332&_gl=1*1ubwjf*_ga*NTA5MjA0MjA0LjE2NzM0MDg0ODI.*_ga_CW55HF8NVT*MTY5NTkzMDMwMy44Ny4xLjE2OTU5MzExMDQuMjAuMC4w",
    "https://storage.googleapis.com/generativeartbucket1/eezyl/20231004-025949/20231004-025949-1.webp",
    "https://storage.googleapis.com/generativeartbucket1/eezyl/20231004-025949/20231004-025949-0.webp",
    "https://firebasestorage.googleapis.com/v0/b/orbofibluesky-7f04d.appspot.com/o/danny_generations%2Fphoto_2023-09-28_15-46-05.jpg?alt=media&token=e298f36b-3e15-4ad3-93ee-145143c6d093&_gl=1*12agna0*_ga*NTA5MjA0MjA0LjE2NzM0MDg0ODI.*_ga_CW55HF8NVT*MTY5NTkzMDMwMy44Ny4xLjE2OTU5MzExMTkuNS4wLjA.",
    "https://storage.googleapis.com/generativeartbucket1/eezyl/20231004-023057/20231004-023057-1.webp",
  ];

  // Initialize Firebase
  const db = getFirestoreInstance();





  const uploadData = async () => {

    if (name.length < 2)
    {
      toast.error("Make sure you have a name with more than 2 characters!");
      return;
    }
    if (description.length < 2)
    {
      toast.error("Make sure you have a description with more than 2 characters!");
      return
    }
    if (inputPrompt.length < 2)
    {
      toast.error("Make sure you have an Input Prompt with more than 10 characters!");
      return
    }
    if (activeImage == "https://firebasestorage.googleapis.com/v0/b/orbofibluesky-7f04d.appspot.com/o/chat-default-image.png?alt=media&token=936b0f65-f711-4153-a1d9-0f1250ad1411")
    {
      toast.error("Make sure you have selected an Avatar Image");
      return
    }
    setIsUploading(true);

    console.log("Running Talking Head");

    sendMessageHeadIntro();


    // Add your upload logic here
  };

  const handleInputPromptChange = (e) => {
    setInputPrompt(e.target.value);
  };

  // useEffect(() => {
  //   console.log(props);
  // })


  const location = useLocation();

  // useEffect(() => {



  //   if (location.state.inputImage != null)
  //   {
  //     console.log("SENT DATA=");
  //     console.log(location.state);
  //     setActiveImage(location.state.inputImage);

  //     const selectedVoiceName = location.state.voice;
  //     const selectedVoice = voices.find(
  //       (voice) => voice.name === selectedVoiceName
  //     );

  //     setIsPlaying(false);

  //     if (selectedVoice)
  //     {
  //       setSelectedValue(selectedVoice.value);
  //       setSelectedSample(selectedVoice.sample);
  //     }
  //     setSelectedVoiceForSelectBox(location.state.voice);
  //     // setSelectedValue(location.state.voice);
  //   }
  // })

  const fileInputRef = useRef(null);

  const handleImageClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file)
    {
      const reader = new FileReader();
      reader.onload = (e) => {
        setActiveImage(e.target.result);
        // setFaceOrAudioToggle(true);
        setGeneratedImages([e.target.result]);
        setIsRegenerated(true)
        setselectedAvatarURL(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const [transcript, setTranscript] = useState('');
  const [isListening, setIsListening] = useState(false);
  const inputRef = useRef(null);

  const [audioUrl, setAudioUrl] = useState('');

  const startListening = () => {
    // setCurrentMessage("");
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

    if (SpeechRecognition)
    {
      const recognition = new SpeechRecognition();
      recognition.interimResults = true;

      recognition.onresult = (event) => {
        let interimTranscript = '';
        for (let i = event.resultIndex; i < event.results.length; i++)
        {
          const transcriptionSegment = event.results[i][0].transcript;
          if (event.results[i].isFinal)
          {
            // setCurrentMessage((prev) => prev + transcriptionSegment);
          } else
          {
            console.log(transcriptionSegment);
            interimTranscript += transcriptionSegment;
            setCurrentMessage(interimTranscript);
          }
        }
        inputRef.current.value = transcript + interimTranscript;
      };

      recognition.onstart = () => {
        setIsListening(true);
      };

      recognition.onend = () => {
        setIsListening(false);
      };

      recognition.start();
    } else
    {
      toast.error('Speech Recognition API not supported in this browser.');
    }
  };

  // const audioRef = useRef(null);

  // useEffect(() => {
  //   // try
  //   // {
  //   const audioElement = audioRef.current;
  //   if (audioElement)
  //   {
  //     // Do something with audioElement
  //     console.log('Audio element is now accessible:', audioElement);
  //   }

  //   // Add event listener to detect when audio playback has ended
  //   audioElement.addEventListener("ended", handleAudioEnd);

  //   // Cleanup listener on component unmount
  //   return () => {
  //     audioElement.removeEventListener("ended", handleAudioEnd);
  //   };
  //   // } catch (e)
  //   // {

  //   // }

  // }, []);

  const handleAudioEnd = () => {
    // Restart the audio when it ends
    audioRef.current.play();
  };

  const togglePlayback = () => {
    const audioElement = audioRef.current;

    if (isPlaying)
    {
      audioElement.pause();
    } else
    {
      audioElement.play();
    }

    setIsPlaying(!isPlaying);
  };

  const videoRef = useRef(null);
  const [countDown, setCountDown] = React.useState(0);
  const [runTimer, setRunTimer] = React.useState(false);
  const [isAudio, setIsAudio] = React.useState(false);
  const [isVideo, setIsVideo] = React.useState(true);
  const [timerRate, setTimerRate] = useState(2000);

  useEffect(() => {
    if (avatarVideoUrl && videoRef.current)
    {

      videoRef.current.addEventListener('loadedmetadata', () => {
        videoRef.current.play();
      });

      videoRef.current.load();  // Ensure the new source is loaded
    }
  }, [avatarVideoUrl]);

  // useEffect(() => {
  //   if (speechGenData.length > 1)
  //   {

  //     console.log(selectedOption.value);

  //     const newArray = speechGenData[selectedOption.value].map((item) => {
  //       return {
  //         value: item.voice,
  //         name: item.voice,
  //         language: location.state.language,
  //         // ... any additional keys you want
  //       };
  //     });

  //     setVoices(newArray);

  //     console.log(newArray[0]);
  //   }
  // }, [speechGenData]);

  const [isGenerating, setIsGenerating] = useState(false);
  const [hasGenerated, setHasGenerating] = useState(true);
  const [isRegenerated, setIsRegenerated] = useState(false);

  const [isGeneratingImage, setIsGeneratingImage] = useState(false);
  const [hasGeneratedImage, setHasGeneratingImage] = useState(false);

  const [superenhance, setSuperenhance] = useState(false);

  const handleCheckboxChange = (event) => {
    setSuperenhance(event.target.checked);
  };


  const [generatedImages, setGeneratedImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState([]);
  const [message, setMessage] = useState(
    "realistic portrait of a professional young man, real life, high quality, colored"
  );
  const [faceOrAudioToggle, setFaceOrAudioToggle] = useState(false);

  const handlePromptChange = (event) => {
    setMessage(event.target.value);
  };

  const [show, setShow] = useState(false);
  const [sliderValue1, setSliderValue1] = useState(50);
  const [sliderValue2, setSliderValue2] = useState(50);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleSliderChange1 = (e) => setSliderValue1(e.target.value);
  const handleSliderChange2 = (e) => setSliderValue2(e.target.value);


  const [voices, setVoices] = useState([]);
  const [selectedVoice, setSelectedVoice] = useState(null);

  let [resultt, setResultt] = useState("");

  const resultRef = useRef();

  useEffect(() => {
    resultRef.current = resultt;
  }, [resultt]);

  // const [languages, setLanguages] = useState([
  //   "English",
  //   "Spanish",
  //   "Chinese",
  //   "French",
  //   "Japanese",
  //   "Arabic",
  //   "German"
  // ]);


  var models = [
    {
      value: 1,
      text: "Llama2",
      icon: <Icon icon="emojione:flag-for-united-states" />,
    },
    {
      value: 2,
      text: "ChatGPT",
      icon: <Icon icon="emojione:flag-for-spain" />,
    },

  ];
  const [chosenModel, setChosenModel] = useState("Llama2");

  const [languages, setLanguages] = useState([]);
  useEffect(() => {
    // This code will run after the component renders
    // and also every time `languages` changes.

    console.log('languages state has changed:', languages);

    // Any other side effects related to the change in `languages` can be placed here.

  }, [languages]); // <- Notice the `languages` dependency in this array
  // var languages = [
  //   {
  //     value: 1,
  //     text: "English",
  //     icon: <Icon icon="emojione:flag-for-united-states" />,
  //   },
  //   {
  //     value: 2,
  //     text: "Spanish",
  //     icon: <Icon icon="emojione:flag-for-spain" />,
  //   },
  //   {
  //     value: 3,
  //     text: "Chinese",
  //     icon: <Icon icon="emojione:flag-for-china" />,
  //   },
  //   {
  //     value: 4,
  //     text: "French",
  //     icon: <Icon icon="emojione:flag-for-france" />,
  //   },
  //   {
  //     value: 5,
  //     text: "Japanese",
  //     icon: <Icon icon="emojione:flag-for-japan" />,
  //   },
  //   {
  //     value: 6,
  //     text: "Arabic",
  //     icon: <Icon icon="emojione:flag-for-united-arab-emirates" />,
  //   },
  //   {
  //     value: 7,
  //     text: "German",
  //     icon: <Icon icon="emojione:flag-for-germany" />,
  //   },
  // ];
  const [chosenLanguage, setSelectedLanguage] = useState("English (US)");

  const [selectedModelOption, setSelectedModelOption] = useState({
    value: 1,
    text: "Llama2",
    icon: <Icon icon="emojione:flag-for-united-states" />,
  });
  const [selectedOption, setSelectedOption] = useState({ "value": "English (US)", "label": 'English (US)', });

  function replaceDannyTrejo(str) {
    return str.replace(/Danny Trejo|danny trejo/g, '<lora:danny2500:1.3>');
  }


  const [selectedValue, setSelectedValue] = useState("Angel");
  const [selectedSample, setSelectedSample] = useState("");
  const [selectedVoiceForSelectBox, setSelectedVoiceForSelectBox] = useState();
  const audioRef2 = useRef(null);

  const handleVoiceChange = (event) => {
    setSelectedVoice(event.target.value);

    setIsPlaying(false);
    if (audioRef.current)
    {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  };

  const playPreview = () => {
    if (audioRef2.current)
    {
      audioRef2.current.play();
    }
  };

  const pausePreview = () => {
    if (audioRef2.current)
    {
      audioRef2.current.pause();
    }
  };

  const selectedVoiceSample = voices.find(
    (voice) => voice.value === selectedVoice
  )?.sample;

  useEffect(() => {
    // try
    // {
    // try
    // {
    //   if (location.state.generated_intro_vid != null)
    //   {
    //     setHasGenerating(true);
    //     setIsVideo(true);

    //     var idleAnimList = location.state.generated_intro_vid.split('/');
    //     var idleAnim = idleAnimList[idleAnimList.length - 1];

    //     setIdleAnimation(idleAnim);

    //     setUrl(`${location.state.generated_hello_vid}?backup=${idleAnim}`);
    //     setUrl2(`${location.state.generated_intro_vid}?backup=${idleAnim}`);



    //   }
    // } catch (e)
    // {
    //   console.log(e);
    // }


    const fetchData = async () => {
      await fetch('https://speechgen.io/index.php?r=api/voices')
        .then(response => {
          // Check if the request was successful
          if (response.status === 200)
          {
            return response.json();
          } else
          {
            throw new Error(`Failed: ${response.statusText}`);
          }
        })
        .then(data => {

          const newList = data;

          //set languages
          setSpeechGenData(newList);
          const languages_temp = Object.keys(newList);
          const options = languages_temp.map(language => ({ value: language, label: language }));
          setLanguages(options);

          //set voices
          var newArray = data['English (US)'].map((item) => {
            return {
              value: item.voice,
              name: item.voice,
              language: 'English (US)',
              // ... any additional keys you want
            };
          });

          newArray = [{
            'value': 'Fast',
            'name': 'Fast',
            'language': 'Fast',
          }, {
            'value': 'Danny Trejo',
            'name': 'Danny Trejo',
            'language': 'Danny Trejo',
          }, ...newArray]

          // var randNum = getRandomNumber(0, 5);
          setVoices(newArray);
          // setSelectedVoiceForSelectBox(location.state.voice);
          // setSelectedValue(location.state.voice.value);

          try
          {
            // if (location.state.inputImage != null)
            // {
            //   // setActiveImage(location.state.inputImage);
            //   // setGeneratedImages([location.state.inputImage]);
            //   // setIsRegenerated(true)


            //   // const findLanguageByText = (searchText) => {
            //   //   return languages.find(language => language.text === searchText);
            //   // };
            //   // const selectedLanguage = findLanguageByText(location.state.language);
            //   // setSelectedOption(location.state.language);
            //   // console.log(location.state.language.name);
            //   // console.log(newList);
            //   // console.log(newList[location.state.language.name]);

            //   // var lst = newList[location.state.language.name];
            //   // const newArray = lst.map((item) => {
            //   //   return {
            //   //     value: item.voice,
            //   //     name: item.voice,
            //   //     language: location.state.language.name,
            //   //     // ... any additional keys you want
            //   //   };
            //   // });
            //   //set voices
            //   // const newArray = speechGenData[location.state.language.name].map((item) => {
            //   //   return {
            //   //     value: item.voice,
            //   //     name: item.voice,
            //   //     language: location.state.language,
            //   //     // ... any additional keys you want
            //   //   };
            //   // });
            //   // setSelectedLanguage(location.state.language.name);
            //   // setVoices(newArray);
            //   // console.log(newArray);
            //   // console.log(newArray[0]);



            //   // setSelectedVoiceForSelectBox({ "value": location.state.voice, "name": location.state.voice, 'language': location.state.language.name });
            //   // setSelectedValue(location.state.voice);

            //   //set talking head parameters
            //   // setYaw(location.state.yawScale);
            //   // setHeadMovement(location.state.expression_scale);
            //   // setPitchScale(location.state.pitchScale);
            //   // setRollScale(location.state.rollScale);



            //   // setSelectedLanguage(location.state.language);
            //   // setSelectedOption({ "value": location.state.language, "name": location.state.language, "language": location.state.language, })

            //   // setSelectedValue(location.state.voice);
            //   // setSelectedVoiceForSelectBox({ 'name': location.state.voice, 'value': location.state.voice, 'sample': location.state.voice });

            //   // console.log("LANGUAGE= ");

            //   // console.log(speechGenData[location.state.language]);




            //   // const newArray = speechGenData[location.state.language].map((item) => {
            //   //   return {
            //   //     value: item.voice,
            //   //     name: item.voice,
            //   //     language: location.state.language,
            //   //     // ... any additional keys you want
            //   //   };
            //   // });

            //   // // setVoices(newArray);

            //   // console.log(newArray[0]);




            //   //set input prompt
            //   // setInputPrompt(location.state.inputPrompt);

            //   //set voice
            //   // const selectedVoiceName = location.state.voice;
            //   // const selectedVoice = filteredVoices.find(
            //   //   (voice) => voice.name === selectedVoiceName
            //   // );
            //   // console.log(selectedVoice);
            //   // setSelectedVoiceForSelectBox(selectedVoice);
            //   // if (selectedVoice)
            //   // {
            //   //   setSelectedValue(selectedVoice.value);
            //   //   // setSelectedSample(selectedVoice.sample);
            //   // }
            // } else
            // {
            //   setIsCreating(true);
            // }
          } catch (e)
          {
            setIsCreating(false);
          }

          // set voices & language
          // setSelectedVoiceForSelectBox({ 'name': data['English (US)'][0].voice, 'value': data['English (US)'][0].voice, 'sample': data['English (US)'][0].voice });
          // setSelectedValue(newList['English (US)'][0].voice);


          // console.log(`Success: ${Object.keys(data)}`);
          // console.log(typeof Object.keys(data));
          // setLanguages(Object.keys(data));
          // const languages_temp = ["Premium Voices", ...Object.keys(data)]


          // console.log(languages_temp);



          // console.log("options");


          // const newList = [premiumVoices, ...options];





          // const newArray = speechGenData['English (US)'].map((item) => {
          //   return {
          //     value: item.voice,
          //     name: item.voice,
          //     language: 'English (US)',
          //     // ... any additional keys you want
          //   };
          // });

          // console.log("VOICES");
          // console.log(newArray);

          // setVoices(newArray);

          // setSelectedVoiceForSelectBox({ 'name': newList['English (US)'][0].voice, 'value': newList['English (US)'][0].voice, 'sample': newList['English (US)'][0].voice });
          // setSelectedValue(newList['English (US)'][0].voice);

          // console.log("LANGUAGES:");
          // console.log(languages);
        })
        .catch(error => {
          console.log(error);
        });


      // const url = "https://play.ht/api/v1/getVoices";
      // const options = {
      //   method: "GET",
      //   headers: {
      //     accept: "application/json",
      //     AUTHORIZATION: "Bearer 8a2f84fbe0694f768083dcbc62fee063",
      //     "X-USER-ID": "DKvC8LJWfVYiFwly0WcGADPW5xb2",
      //   },
      // };
      // // console.log(`SessionID: `);


      // try
      // {
      //   console.log("RETRIEVED VOICES:")
      //   const response = fetch(url, options).then(response => {
      //     // Check if the request was successful
      //     if (response.status === 200)
      //     {
      //       return response.json();
      //     } else
      //     {
      //       throw new Error(`Failed: ${response.statusText}`);
      //     }
      //   })
      //     .then(data => {

      //       console.log(data);

      //       data.voices.splice(0, 2);
      //       var filteredVoices = data.voices.filter(

      //         (voice) => voice.languageCode === "en-US"
      //       );
      //       // filteredVoices.append({
      //       //   'name': 'Danny Trejo',
      //       //   'sample': 'local'
      //       // })
      //       filteredVoices = [
      //         ...filteredVoices,
      //         {
      //           name: "Joe Rogan",
      //           value: "Joe Rogan",
      //           sample: "local",
      //         },
      //       ];
      //       filteredVoices = [
      //         ...filteredVoices,
      //         {
      //           name: "Andrew Tate",
      //           value: "Andrew Tate",
      //           sample: "local",
      //         },
      //       ];

      //       filteredVoices = [
      //         ...filteredVoices,
      //         {
      //           name: "Danny Trejo",
      //           value: "Danny Trejo",
      //           sample: "local",
      //         },
      //       ];
      //       filteredVoices = filteredVoices.reverse();
      //       filteredVoices = filteredVoices.filter(
      //         (voice) => voice.name !== "Nancy"
      //       );
      //       console.log("FILTERED VOICES:");
      //       console.log(filteredVoices)

      //       const newTestArray = filteredVoices.map((item) => {
      //         return {
      //           voice: item.name,
      //           cpm: 1,
      //           pro: '1'
      //           // voice: item.name,
      //           // ... any additional keys you want
      //         };
      //       });
      //       console.log(newTestArray);
      //       fetch('https://speechgen.io/index.php?r=api/voices')
      //         .then(response => {
      //           // Check if the request was successful
      //           if (response.status === 200)
      //           {
      //             return response.json();
      //           } else
      //           {
      //             throw new Error(`Failed: ${response.statusText}`);
      //           }
      //         })
      //         .then(data => {
      //           // console.log("DATA");
      //           // console.log(data);
      //           // console.log(newTestArray);
      //           // allData = data;
      //           // console.log(premiumVoices);
      //           const newElement = { 'Premium Voices': newTestArray };
      //           const newList = { ...data, ...newElement }
      //           console.log("SPEECHGENDATA:");
      //           console.log(newList);

      //           //set languages
      //           setSpeechGenData(newList);
      //           const languages_temp = Object.keys(newList);
      //           const options = languages_temp.map(language => ({ value: language, label: language }));
      //           console.log(options);
      //           setLanguages(options);

      //           //set voices
      //           const newArray = data['English (US)'].map((item) => {
      //             return {
      //               value: item.voice,
      //               name: item.voice,
      //               language: 'English (US)',
      //               // ... any additional keys you want
      //             };
      //           });
      //           setVoices(newArray);
      //           console.log(newArray[0]);
      //           setSelectedVoiceForSelectBox(newArray[4]);
      //           setSelectedValue(newArray[4].value);

      //           try
      //           {
      //             if (location.state.inputImage != null)
      //             {
      //               console.log("SENT DATA=");
      //               console.log(location.state);
      //               setActiveImage(location.state.inputImage);
      //               setGeneratedImages([location.state.inputImage]);
      //               setIsRegenerated(true)

      //               //set language
      //               // setSelectedLanguage(location.state.language);
      //               // const findLanguageByText = (searchText) => {
      //               //   return languages.find(language => language.text === searchText);
      //               // };
      //               // const selectedLanguage = findLanguageByText(location.state.language);
      //               // setSelectedOption(location.state.language);
      //               // console.log(location.state.language.name);
      //               // console.log(newList);
      //               // console.log(newList[location.state.language.name]);

      //               // var lst = newList[location.state.language.name];
      //               // const newArray = lst.map((item) => {
      //               //   return {
      //               //     value: item.voice,
      //               //     name: item.voice,
      //               //     language: location.state.language.name,
      //               //     // ... any additional keys you want
      //               //   };
      //               // });
      //               //set voices
      //               // const newArray = speechGenData[location.state.language.name].map((item) => {
      //               //   return {
      //               //     value: item.voice,
      //               //     name: item.voice,
      //               //     language: location.state.language,
      //               //     // ... any additional keys you want
      //               //   };
      //               // });
      //               // setSelectedLanguage(location.state.language.name);
      //               setVoices(newArray);
      //               console.log(newArray);
      //               // console.log(newArray[0]);



      //               // setSelectedVoiceForSelectBox({ "value": location.state.voice, "name": location.state.voice, 'language': location.state.language.name });
      //               // setSelectedValue(location.state.voice);

      //               //set talking head parameters
      //               // setYaw(location.state.yawScale);
      //               // setHeadMovement(location.state.expression_scale);
      //               // setPitchScale(location.state.pitchScale);
      //               // setRollScale(location.state.rollScale);



      //               // setSelectedLanguage(location.state.language);
      //               // setSelectedOption({ "value": location.state.language, "name": location.state.language, "language": location.state.language, })

      //               // setSelectedValue(location.state.voice);
      //               // setSelectedVoiceForSelectBox({ 'name': location.state.voice, 'value': location.state.voice, 'sample': location.state.voice });

      //               // console.log("LANGUAGE= ");

      //               // console.log(speechGenData[location.state.language]);




      //               // const newArray = speechGenData[location.state.language].map((item) => {
      //               //   return {
      //               //     value: item.voice,
      //               //     name: item.voice,
      //               //     language: location.state.language,
      //               //     // ... any additional keys you want
      //               //   };
      //               // });

      //               // // setVoices(newArray);

      //               // console.log(newArray[0]);




      //               //set input prompt
      //               setInputPrompt(location.state.inputPrompt);

      //               //set voice
      //               // const selectedVoiceName = location.state.voice;
      //               // const selectedVoice = filteredVoices.find(
      //               //   (voice) => voice.name === selectedVoiceName
      //               // );
      //               // console.log(selectedVoice);
      //               // setSelectedVoiceForSelectBox(selectedVoice);
      //               // if (selectedVoice)
      //               // {
      //               //   setSelectedValue(selectedVoice.value);
      //               //   // setSelectedSample(selectedVoice.sample);
      //               // }
      //             } else
      //             {
      //               console.log("CREATING");
      //               setIsCreating(true);
      //             }
      //           } catch (e)
      //           {
      //             console.log(e);
      //             console.log("CREATING");
      //             setIsCreating(true);
      //           }

      //           // set voices & language
      //           // setSelectedVoiceForSelectBox({ 'name': data['English (US)'][0].voice, 'value': data['English (US)'][0].voice, 'sample': data['English (US)'][0].voice });
      //           // setSelectedValue(newList['English (US)'][0].voice);


      //           // console.log(`Success: ${Object.keys(data)}`);
      //           // console.log(typeof Object.keys(data));
      //           // setLanguages(Object.keys(data));
      //           // const languages_temp = ["Premium Voices", ...Object.keys(data)]


      //           // console.log(languages_temp);



      //           // console.log("options");


      //           // const newList = [premiumVoices, ...options];





      //           // const newArray = speechGenData['English (US)'].map((item) => {
      //           //   return {
      //           //     value: item.voice,
      //           //     name: item.voice,
      //           //     language: 'English (US)',
      //           //     // ... any additional keys you want
      //           //   };
      //           // });

      //           // console.log("VOICES");
      //           // console.log(newArray);

      //           // setVoices(newArray);

      //           // setSelectedVoiceForSelectBox({ 'name': newList['English (US)'][0].voice, 'value': newList['English (US)'][0].voice, 'sample': newList['English (US)'][0].voice });
      //           // setSelectedValue(newList['English (US)'][0].voice);

      //           // console.log("LANGUAGES:");
      //           // console.log(languages);
      //         })
      //         .catch(error => {
      //           console.log(error);
      //         });
      //       console.log(location.state);


      //     });




      //   //set chatbot parameters


      //   // if (location.state.created_by == "1")
      //   // {

      //   // }
      // } catch (error)
      // {
      //   console.error("Error fetching voices:", error);
      // }


    };

    fetchData();


  }, []); // empty dependency array means this useEffect runs once after initial render

  const [avatarImageUrlSelected, setAvatarImageUrl] = useState("");
  const [isAvatarGenerated, setIsAvatarGenerated] = useState(false);
  const [selectedAvatarURL, setselectedAvatarURL] = useState("");


  const handleCategoryChange = (event) => {
    const selectedVoiceName = event.name;
    const selectedVoice = voices.find(
      (voice) => voice.name === selectedVoiceName
    );

    setIsPlaying(false);

    if (selectedVoice)
    {
      setSelectedValue(selectedVoice.value);
      // setSelectedSample(selectedVoice.sample);
    }
    setSelectedVoiceForSelectBox(event);
    // your logic here
  };

  const handleModelChange = (event) => {
    const selectedLanguage = event.text;

    setChosenModel(selectedLanguage);
    setSelectedModelOption(event);
    // your logic here
  };

  const handleLanguageChange = (event) => {
    const selectedLanguage = event.value;
    setSelectedLanguage(selectedLanguage);

    // setSelectedLanguage(selectedLanguage);
    setSelectedOption({ "value": selectedLanguage, "name": selectedLanguage, "language": selectedLanguage, });

    // console.log(speechGenData[event.value]);

    const newArray = speechGenData[event.value].map((item) => {
      return {
        value: item.voice,
        name: item.voice,
        language: selectedLanguage,
        // ... any additional keys you want
      };
    });

    setVoices(newArray);


    setSelectedVoiceForSelectBox(newArray[0]);
    setSelectedValue(newArray[0].value);
    setSelectedOption({ "value": selectedLanguage, "name": selectedLanguage, "language": selectedLanguage, });
    // your logic here
  };

  const [activeImage, setActiveImage] = useState('');
  // useEffect(() => {
  //   if (isThemeDark)
  //   {
  //     setActiveImage("https://firebasestorage.googleapis.com/v0/b/orbofibluesky-7f04d.appspot.com/o/chat-default-image.png?alt=media&token=936b0f65-f711-4153-a1d9-0f1250ad1411")
  //   } else
  //   {
  //     setActiveImage("https://firebasestorage.googleapis.com/v0/b/orbofibluesky-7f04d.appspot.com/o/dark-img-upload.png?alt=media&token=474bcca1-fd06-44d8-8c2e-2898651dbb60&_gl=1*11hdrzi*_ga*NDI5MDg0OTczLjE2ODI0Njk1NzQ.*_ga_CW55HF8NVT*MTY5NjI1MjY2MS41LjEuMTY5NjI1MjY4Ni4zNS4wLjA")
  //   }
  // }, [isThemeDark])
  // const location = useLocation();
  // const avatarImageUrl = location.state?.avatarImageUrl;

  // let [, setInputIm] = React.useState("");
  // let [pair, setPair] = React.useState("");
  // let query = window.location.search.substring(1);
  // let vars = query.split("&");
  // useEffect(() => {
  //   let tmpPair = vars[0]?.split("=");

  //   // if (tmpPair[1] == null) {
  //   //   console.log("no image");
  //   // } else {
  //   //   console.log(tmpPair[1]);
  //   //   setAvatarImageUrl(tmpPair[1]);
  //   //   // setAvatarImageUrl(image);
  //   // }

  //   // setInputIm(tmpPair);  // Assuming setting inputIm doesn't need any condition

  //   // if (tmpPair[0] === "url" && JSON.stringify(pair) !== JSON.stringify(tmpPair)) {
  //   //     setPair(tmpPair);
  //   // }
  // }, [vars]);

  const playAudio = async () => {
    // Your function here...
    // This is where your function finishes running.
    // Let's play the audio now.
    // audioRef.current.play();
  };

  const onSelectImages = (image, index) => {
    let allImage = selectedImage;
    let updateGeneratedImage = [...generatedImages];
    if (image.isChecked)
    {
      updateGeneratedImage[index].isChecked = false;
      const imgIndex = allImage.indexOf(image.imageUrl);
      if (index > -1)
      {
        allImage.splice(imgIndex, 1);
      }
    } else
    {
      updateGeneratedImage[index].isChecked = true;
      allImage.push(image.imageUrl);
    }
    setGeneratedImages(updateGeneratedImage);
    setIsRegenerated(true)
    setSelectedImage(allImage);
  };
  // const onShowTokenize = () => {
  //   if (authToken) {
  //     setShowTokenNize(true);
  //   } else {
  //     setShowLoginPopup(true);
  //   }
  // };

  const fetchGeneration = async () => {
    const controller = new AbortController();
    const signal = controller.signal;

    setGeneratedImages([]);
    setCountDown(0);

    // const db = getFirestore();

    // const db = getFirestore();

    // const db = firebase.firestore();

    var isUploaded = false;
    try
    {
      if (location.state.voice == "Danny Trejo" || message.toLowerCase().includes('danny trejo') || selectedVoice == "Danny Trejo")
      {

        setTimerRate(500);
        // setGeneratedImages([]);
        // const aspect1 = document.getElementById("AspectRatio01").checked;
        // // togglerTimer();
        // document.getElementById("progressClass").style.display = "block";
        // document.getElementById("BtnGenerate").style.display = "block";

        setIsGeneratingImage((t) => true);

        setHasGeneratingImage((t) => false);
        setRunTimer((t) => true);

        var tmpMessage = `${replaceDannyTrejo(message)}`



        await fetch(
          `https://yjbx86uhoesmxn-3000.proxy.runpod.net/factory_inference?model_uid=danny-trejo-ai&prompt=${tmpMessage}&cgs=8&steps=20&n_imgs=4&email=${userData?.email}`,
          {
            headers: {
              connection: "keep-alive",
              // 'content-type': 'application/json'
            },
            keepalive: true,
            timeout: 8000000,
          }
        )
          .then((response) => response.json())
          .then(async (data) => {
            setRunTimer((t) => false);
            setCountDown(100);
            setTimeout(() => {
              let allImages = [];
              data.map((image) => {
                const newData = {
                  imageUrl: image,
                  isChecked: false,
                };
                allImages.push(newData);
              });

              setGeneratedImages(allImages);
              setIsRegenerated(true)
              setActiveImage(allImages[0].imageUrl);
              setIsAvatarGenerated(true);
              setSelectedImage();



              setIsGeneratingImage((t) => false);
              setHasGeneratingImage(true);
            }, 1000);


            // useEffect(() => {
            // //   const fetchData = async () => {
            // const docRef = doc(db, 'FactoryRecents', qty);
            // const docSnap = await getDoc(docRef);

            // if (docSnap.exists()) {
            //   setRecentGenerations(docSnap.data()['recent_generations'].reverse());
            // } else {
            //   console.log('No such document!');
            // }
            //   };

            //   fetchData();
            // }, [qty]);
          })
          .catch((error) => {
            // toast.error(error.message);
            setRunTimer((t) => false);
            setCountDown(0);
            setIsGeneratingImage((t) => false);
            setHasGeneratingImage(false);
          });
      }
      else
      {

        setTimerRate(180);
        // setGeneratedImages([]);
        // const aspect1 = document.getElementById("AspectRatio01").checked;
        // // togglerTimer();
        // document.getElementById("progressClass").style.display = "block";
        // document.getElementById("BtnGenerate").style.display = "block";

        setIsGeneratingImage((t) => true);

        setHasGeneratingImage((t) => false);
        setRunTimer((t) => true);



        await fetch(
          `https://yjbx86uhoesmxn-3000.proxy.runpod.net/factory_inference?model_uid=sdxl&prompt=${message}&cgs=8&steps=20&n_imgs=4&email=${userData?.email}`,
          {
            headers: {
              connection: "keep-alive",
              // 'content-type': 'application/json'
            },
            keepalive: true,
            timeout: 8000000,
          }
        )
          .then((response) => response.json())
          .then(async (data) => {

            setCountDown(100);
            setRunTimer((t) => false);
            setTimeout(() => {
              let allImages = [];
              data.map((image) => {
                const newData = {
                  imageUrl: image,
                  isChecked: false,
                };
                allImages.push(newData);
              });

              setGeneratedImages(allImages);
              setIsRegenerated(true)
              setActiveImage(allImages[0].imageUrl);
              setIsAvatarGenerated(true);
              setSelectedImage();



              setIsGeneratingImage((t) => false);
              setHasGeneratingImage(true);
            }, 1000);

            // useEffect(() => {
            // //   const fetchData = async () => {
            // const docRef = doc(db, 'FactoryRecents', qty);
            // const docSnap = await getDoc(docRef);

            // if (docSnap.exists()) {
            //   setRecentGenerations(docSnap.data()['recent_generations'].reverse());
            // } else {
            //   console.log('No such document!');
            // }
            //   };

            //   fetchData();
            // }, [qty]);
          })
          .catch((error) => {
            // toast.error(error.message);
            setRunTimer((t) => false);
            setCountDown(0);
            setIsGeneratingImage((t) => false);
            setHasGeneratingImage(false);
          });
      }
    } catch (e)
    {
      setTimerRate(350);
      // setGeneratedImages([]);
      // const aspect1 = document.getElementById("AspectRatio01").checked;
      // // togglerTimer();
      // document.getElementById("progressClass").style.display = "block";
      // document.getElementById("BtnGenerate").style.display = "block";

      setIsGeneratingImage((t) => true);

      setHasGeneratingImage((t) => false);
      setRunTimer((t) => true);



      await fetch(
        `https://yjbx86uhoesmxn-3000.proxy.runpod.net/factory_inference?model_uid=sdxl&prompt=${message}&cgs=8&steps=20&n_imgs=4&email=${userData?.email}`,
        {
          headers: {
            connection: "keep-alive",
            // 'content-type': 'application/json'
          },
          keepalive: true,
          timeout: 8000000,
        }
      )
        .then((response) => response.json())
        .then(async (data) => {
          setRunTimer((t) => false);
          setCountDown(100);
          let allImages = [];
          data.map((image) => {
            const newData = {
              imageUrl: image,
              isChecked: false,
            };
            allImages.push(newData);
          });

          setGeneratedImages(allImages);
          setIsRegenerated(true)
          setActiveImage(allImages[0].imageUrl);
          setIsAvatarGenerated(true);
          setSelectedImage();



          setIsGeneratingImage((t) => false);
          setHasGeneratingImage(true);

          // useEffect(() => {
          // //   const fetchData = async () => {
          // const docRef = doc(db, 'FactoryRecents', qty);
          // const docSnap = await getDoc(docRef);

          // if (docSnap.exists()) {
          //   setRecentGenerations(docSnap.data()['recent_generations'].reverse());
          // } else {
          //   console.log('No such document!');
          // }
          //   };

          //   fetchData();
          // }, [qty]);
        })
        .catch((error) => {
          // toast.error(error.message);
          setRunTimer((t) => false);
          setCountDown(0);
          setIsGeneratingImage((t) => false);
          setHasGeneratingImage(false);
        });
    }

    // try {

    // setTimeout(() => {
    //   controller.abort();
    // }, 120000); // 2 minutes (120000 milliseconds) timeout
    // if (authToken) {


    // } else {
    //   setShowLoginPopup(true);
    // }
    return () => {
      // Clean up the controller when the component is unmounted
      controller.abort();
    };
  }

  // useEffect(() => {
  //   playAudio();
  // }, []);

  // useEffect(() => {
  //     console.log(pair[1]);
  // }, [pair]);

  React.useEffect(() => {
    let timerId;

    if (runTimer)
    {
      setCountDown(0);
      timerId = setInterval(() => {
        setCountDown((countDown) => countDown + 1);
      }, timerRate);
    } else
    {
      clearInterval(timerId);
    }

    return () => clearInterval(timerId);
  }, [runTimer, timerRate]);

  React.useEffect(() => {
    if (countDown > 100 && runTimer)
    {
      setRunTimer(false);
      setCountDown(0);
    }
  }, [countDown, runTimer]);

  React.useEffect(() => {
    if (countDown > 100 && runTimer)
    {
      setRunTimer(false);
      setCountDown(0);
    }
  }, [countDown, runTimer]);

  const convertMessages = (messages) => {
    const formattedMessages = messages.map((message) => ({
      role: message.sender,
      content: message.text,
    }));

    // if (messages.length < 2) {
    formattedMessages.unshift({
      role: 'system',
      content: `You are an Orbofi A.I. Assistant created by the engineers at orbofi. You are able to act as any character given the characteristics that the user inputs. Here is the characteristics you should replicate: ${inputPrompt}. Add lots of punctuation, and keep your sentences short. Maximum 400 characters for your responses.  Conversation begins:\n`
    });
    // }

    return formattedMessages;
  };

  const postData = async (url = "", data = {}) => {
    let now = new Date();
    // setIsTyping(true);
    // setIsGenerating((t) => true);
    setIsLoading(true);

    // setRunTimer((t) => true);

    await fetch(url, {
      method: "POST",
      body: JSON.stringify({
        data,
        // add all other data here
      }),
      headers: {
        "content-type": "application/json",
      },
    })
      .then((response) => response.json())
      .then(async (data) => {
        // setQueueId(data["queue_id"]);
      })
      .catch((error) => {
        // toast.error(error.message);
        // toast.error("RRERERERER");
        // setRunTimer((t) => false);
        // setCountDown(0);
        // setIsGenerating((t) => false);
        // setHasGenerating(false);
        setIsTyping(false);
        setIsLoading(false);
      });
  };

  const postDataAudio = async (url = "", data = {}) => {
    let now = new Date();
    // setIsTyping(true);
    // setIsGenerating((t) => true);
    // setIsLoading(true);

    // setRunTimer((t) => true);



    await fetch(url, {
      method: "POST",
      body: JSON.stringify({
        data,
        // add all other data here
      }),
      headers: {
        "content-type": "application/json",
      },
    })
      .then((response) => response.json())
      .then(async (data) => {
        setIsRunning(false);

        setChatHistory([
          ...newChatHistory,
          {
            text: resultRef.current,
            sender: "system",
            profile: activeImage, //
            audioUrl: data['audio'], //
          },
        ]);
        // return data;

        // setQueueId(data["queue_id"]);
      })
      .catch((error) => {
        // toast.error(error.message);
        // toast.error("RRERERERER");
        // setRunTimer((t) => false);
        // setCountDown(0);
        // setIsGenerating((t) => false);
        // setHasGenerating(false);
        setIsTyping(false);
        // setIsLoading(false);
      });
  };

  const postDataIdle = async (url = "", data = {}) => {
    let now = new Date();
    // setIsTyping(true);
    // setIsGenerating((t) => true);
    // setIsLoading(true);

    // setRunTimer((t) => true);

    await fetch(url, {
      method: "POST",
      body: JSON.stringify({
        data,
        // add all other data here
      }),
      headers: {
        "content-type": "application/json",
      },
    })
      .then((response) => response.json())
      .then(async (data) => {
        // console.log("DATA");
        console.log("DONE IDLE ANIMATION");
        setCountDown(100);
        setIsGenerating(false);
        setIsGeneratingImage((t) => false);
        setRunTimer((t) => false);
        setIsPlayingImage(true);
        setHasGenerating(true);
        setIsVideo(true);
        setUrl(`https://xq3pl2oc187t2f-5000.proxy.runpod.net/hls/${data['text']}?backup=${idleAnimationDefault}`);
        setUrl2(`https://xq3pl2oc187t2f-5000.proxy.runpod.net/hls/${data['text']}?backup=${idleAnimationDefault}`);

        // setU
        // return data;
        // setQueueId(data["queue_id"]);
      })
      .catch((error) => {
        toast.error(error.message);
        // setRunTimer((t) => false);
        // setCountDown(0);
        // setIsGenerating((t) => false);
        // setHasGenerating(false);
        // setIsTyping(false);
        // setIsLoading(false);
      });
  };


  const onSendDirectMessage = (message) => {
    setCurrentMessage(message);
    // sendMessageHead();
  }

  function replaceHtmlCharsWithDot(inputString) {
    // Replace HTML tags with a dot
    let result = inputString.replace(/<\/?[^>]+(>|$)/g, ".");

    // Replace HTML entities with a dot
    result = result.replace(/&[^;\s]+;/g, ".");

    return result;
  }

  function replaceSpecialCharsWithDot(inputString) {
    // Replace specified characters with a dot
    return inputString.replace(/[!:\?]/g, ".");
  }

  const [timerRunning, setTimerRunning] = useState(false);
  const [isVideo1, setIsVideo1] = useState(true);
  const intervalRef = useRef(null); // To keep track of the interval ID

  // useEffect(() => {
  //   if (timerRunning)
  //   {
  //     intervalRef.current = setInterval(async () => {

  //       const response = await fetch('https://lzc6smy1cj2us5-5000.proxy.runpod.net/sessions/get_vid', {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': 'application/json',
  //         },
  //         body: JSON.stringify({
  //           "sessionuid": sessionuid,
  //           'numGenerated': numGenerated
  //         }),
  //       });
  //       const data = await response.json();
  //       console.log(data);

  //       if (data['total_vids'] > 0)
  //       {

  //         // setNumGenerated(numGenerated + 1);
  //         var tmp_url = idleAnimation;

  //         tmp_url = `${data['video']}?backup=${idleAnimationDefault}`;


  //         if (isVideo1)
  //         {
  //           console.log("IS VIDEO 1");
  //           setUrl2(tmp_url);

  //           numGenerated += 1;
  //           setTimerRunning(false);
  //         } else
  //         {
  //           console.log("IS NOT VIDEO 1");
  //           setUrl(tmp_url);
  //           numGenerated += 1;
  //           setTimerRunning(false);

  //         }
  //         console.log("VIDEO IS GENERATED AND READY TO PLAY");
  //       } else
  //       {
  //         tmp_url = idleAnimation;
  //       }
  //     }, 1000);
  //   }

  //   return () => {
  //     if (intervalRef.current) clearInterval(intervalRef.current);
  //   };
  // }, [timerRunning, isVideo1]);


  function splitSentenceAt4thLastSpace(sentence) {
    // Check if the sentence length is more than 50 characters
    if (sentence.length > 50)
    {
      // Initialize splitIndex
      let splitIndex = -1;

      // Find the last 4th space before the 50th character
      for (let i = 0, spaceCount = 0; i < 50; i++)
      {
        if (sentence[i] === ' ')
        {
          spaceCount++;
          if (spaceCount === 4)
          {
            splitIndex = i;
            break;
          }
        }
      }

      // If there's no 4th space, split at the 50th character
      if (splitIndex === -1) splitIndex = 50;

      // Split the sentence into two parts
      let part1 = sentence.substring(0, splitIndex);
      let part2 = sentence.substring(splitIndex + 1);

      return [part1, part2];
    } else
    {
      // If the sentence is less than or equal to 50 characters, return it as is
      return [sentence];
    }
  }

  const streamTextGeneration = async () => {
    if (currentMessage.length < 1)
    {
      toast.error("Make sure input text is greater than 1 character", {
        icon: "👏",
        style: {
          borderRadius: "10px",
          background: "#333",
          color: "#fff",
          position: "bottom-center",
          // index: '1'
        },
      });
      return;

    }
  console.log("M");
    numSentence = 0;
    setIsTyping(true);
    setIsLoading(true);
    setIsProgressing(true);
    setIsGenerating((t) => true);
    setCurrentMessage('');
    setSelectedFiles([]);
    setImagePreviews([]);
    console.log("STREAMING");
    setTimerRunning(true);
    scrollToBottom();


    setselectedAvatarURL(activeImage);

    setResultt("");

    // if (currentMessage.trim() !== "")
    // {

    const newChatHistory = [
      ...chatHistory,
      {
        text: currentMessage,
        sender: "user",
        profile: userData?.profile_picture ?? "/images/profile.png",
        audioUrl: "",
        // videoUrl: '',
      },
      // { text: '', sender: "bot", profile: avatarImageUrlSelected },
    ];
    setChatHistory(newChatHistory);

    console.log(convertMessages(newChatHistory));
    let url = "https://api.openai.com/v1/chat/completions";
    let tmp = {
      model: "gpt-4",
      messages: convertMessages(newChatHistory),
      temperature: 0.75,
      top_p: 0.95,
      // max_tokens: 100,
      stream: true,
      // n: 1,
    };


    let source = new SSE(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer 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`,
      },
      method: "POST",
      payload: JSON.stringify(tmp),
    });

    // setTimeout(() => {
    //   // Code block to execute after 1.5 seconds
    //   console.log('This will run after 1.5 seconds');
    //   setIsTyping(false);
    //   setResultt(resultRef.current);
    // }, 1500);

    // let receivingMessage = false;



    // var t = ""
    if (faceOrAudioToggle)
    {
      source.addEventListener("message", (e) => {
        setIsRunning(true);
        scrollToBottom();


        if (e.data != "[DONE]")
        {

          setIsTyping(false);
          // setIsTyping(false);
          let payload = JSON.parse(e.data);
          // console.log(payload['choices']);
          let text = payload.choices[0].delta['content'];
          if (text != null)
          {
            // console.log("Text: " + text);
            resultRef.current = resultRef.current + text;
            setResultt(resultRef.current);

            var textTosay = "";
            textTosay = replaceHtmlCharsWithDot(resultRef.current);
            textTosay = replaceSpecialCharsWithDot(textTosay);
            // textTosay = splitEveryFourWords(textTosay);
            console.log("TEXT 2 SAY");
            console.log(textTosay);
            if (textTosay.endsWith('.'))
            {
              let sentences = textTosay.split('.');
              console.log("SPLIT SENTENCES ARE: ")
              sentences = sentences.filter(element => element !== "");

              console.log(sentences);
              let lastSentence = sentences[sentences.length - 1];

              console.log("LAST SENTENCE TO GENERATE IS: ")
              console.log(lastSentence);

              if (lastSentence.length > 5)
              {
                console.log(`SENDING SENTENCE: ${lastSentence}`)
                postData(
                  "https://xq3pl2oc187t2f-6000.proxy.runpod.net/talking_voice_clone",
                  {
                    img_url: activeImage,
                    prompt: currentMessage,
                    is_audio: false,
                    dc: convertMessages(chatHistory),
                    voice: selectedValue,
                    language: chosenLanguage,
                    yawScale: yawScale,
                    headMovement: headMovement,
                    pitchScale: pitchScale,
                    rollScale: rollScale,
                    inputPrompt: inputPrompt,
                    superenhance: superenhance,
                    answer: lastSentence,
                    sessionuid: sessionuid,
                    numSentence: numSentence
                  }
                );
                if (numSentence == 0)
                {
                  setisOutputted(false);
                }
                numSentence++;
                console.log("Increasing Number of Sentences...");
              }
              // Make a non-blocking API call



            }

          }

        } else
        {
          // setResultt(resultRef.current);
          source.close();
        }

      });

      source.addEventListener("readystatechange", (e) => {
        if (e.readyState >= 2)
        {
          console.log('COMPLETED');
          // setIsTyping(false);
          isResponseWaiting = true;

          setIsRunning(false);

          setChatHistory([
            ...newChatHistory,
            {
              text: resultRef.current,
              sender: "system",
              profile: activeImage, //
              audioUrl: "", //
            },
          ]);

        }
      });
      source.stream();
    }
    else
    {
      console.log("Audio Generation")
      source.addEventListener("message", (e) => {
        setIsRunning(true);
        setIsTyping(false);
        scrollToBottom();
        if (e.data != "[DONE]")
        {
          setIsTyping(false);
          // setIsTyping(false);
          let payload = JSON.parse(e.data);
          // console.log(payload['choices']);
          let text = payload.choices[0].delta['content'];
          if (text != null)
          {
            // console.log("Text: " + text);
            resultRef.current = resultRef.current + text;
            console.log(resultRef.current);
            setResultt(resultRef.current);

            var textTosay = "";
            textTosay = replaceHtmlCharsWithDot(resultRef.current);
            textTosay = replaceSpecialCharsWithDot(textTosay);
            // textTosay = splitEveryFourWords(textTosay);
            console.log("TEXT 2 SAY");
            console.log(textTosay);
            // if (textTosay.endsWith('.'))
            // {
            //   let sentences = textTosay.split('.');
            //   console.log("SPLIT SENTENCES ARE: ")
            //   console.log(sentences);
            //   let lastSentence = sentences[sentences.length - 2];

            //   console.log("LAST SENTENCE TO GENERATE IS: ")
            //   console.log(lastSentence);

            //   if (lastSentence.length > 8)
            //   {

            //     postData(
            //       "https://lzc6smy1cj2us5-6000.proxy.runpod.net/talking_voice_clone",
            //       {
            //         img_url: activeImage,
            //         prompt: currentMessage,
            //         is_audio: false,
            //         dc: convertMessages(chatHistory),
            //         voice: selectedValue,
            //         language: chosenLanguage,
            //         yawScale: yawScale,
            //         headMovement: headMovement,
            //         pitchScale: pitchScale,
            //         rollScale: rollScale,
            //         inputPrompt: inputPrompt,
            //         superenhance: superenhance,
            //         answer: lastSentence,
            //         sessionuid: sessionuid,
            //         numSentence: numSentence
            //       }
            //     );
            //     numSentence++;
            //     console.log("Increasing Number of Sentences...");
            //   }
            //   // Make a non-blocking API call



            // }

          }

        } else
        {
          // setResultt(resultRef.current);
          source.close();
        }
      });

      var ran = false;

      source.addEventListener("readystatechange", async (e) => {
        if (e.readyState >= 2 && ran == false)
        {
          ran = true;
          console.log('COMPLETED');

          // setIsTyping(false);
          isResponseWaiting = true;



          // const audio_url = postDataAudio(
          //   "https://lzc6smy1cj2us5-6000.proxy.runpod.net/audio_generation",
          //   {
          //     prompt: currentMessage,
          //     is_audio: false,
          //     dc: convertMessages(chatHistory),
          //     voice: selectedValue,
          //     language: chosenLanguage,
          //     yawScale: yawScale,
          //     headMovement: headMovement,
          //     pitchScale: pitchScale,
          //     rollScale: rollScale,
          //     inputPrompt: inputPrompt,
          //     superenhance: superenhance,
          //     answer: resultRef.current,
          //     sessionuid: sessionuid,
          //   }
          // );


          var input_data = {
            prompt: replaceSpecialCharsWithDot(currentMessage),
            is_audio: false,
            dc: convertMessages(chatHistory),
            voice: selectedValue,
            language: chosenLanguage,
            yawScale: yawScale,
            headMovement: headMovement,
            pitchScale: pitchScale,
            rollScale: rollScale,
            inputPrompt: inputPrompt,
            superenhance: superenhance,
            answer: resultRef.current,
            sessionuid: sessionuid,
          }
          await fetch("https://xq3pl2oc187t2f-6000.proxy.runpod.net/audio_generation", {
            method: "POST",
            body: JSON.stringify(input_data // add all other data here
            ),
            headers: {
              "content-type": "application/json",
            },
          })
            .then((response) => response.json())
            .then(async (data) => {
              console.log(data);
              setIsRunning(false);
              setIsProgressing(false);

              setChatHistory([
                ...newChatHistory,
                {
                  text: resultRef.current,
                  sender: "system",
                  profile: activeImage, //
                  audioUrl: data['audio'], //
                },
              ]);
              setIsLoading(false);
              // return data;

              // setQueueId(data["queue_id"]);
            })
            .catch((error) => {
              toast.error(error.message);
              // toast.error("RRERERERER");
              // setRunTimer((t) => false);
              // setCountDown(0);
              // setIsGenerating((t) => false);
              // setHasGenerating(false);
              setIsTyping(false);
              setIsLoading(false);
            });




        }
      });
      source.stream();
      // console.log('test')
    }






  }


  const sendMessageHeadOnPlay = async () => {
    // setIsAudio(false);
    // setIsTyping(true);

    if (superenhance)
    {
      setTimerRate(2000);
    } else
    {
      setTimerRate(800);
    }
    setIsPlaying(false);
    setCountDown(0);

    // if (currentMessage.length < 2)
    // {
    //   // setError(error.message);
    //   // handleShow();
    //   setRunTimer((t) => false);
    //   setCountDown(0);
    //   setIsGenerating((t) => false);
    //   setHasGenerating(false);
    //   toast.error("Make sure input text is greater than 3 characters", {
    //     icon: "👏",
    //     style: {
    //       borderRadius: "10px",
    //       background: "#333",
    //       color: "#fff",
    //       position: "bottom-center",
    //       // index: '1'
    //     },
    //   });
    //   return;
    //   // setError("Make sure input text is greater than 3 characters");

    //   // handleShow();
    // }
    // audioRef.current.pause();

    if (
      activeImage ===
      "https://firebasestorage.googleapis.com/v0/b/orbofibluesky-7f04d.appspot.com/o/chat-default-image.png?alt=media&token=936b0f65-f711-4153-a1d9-0f1250ad1411"
    )
    {
      setRunTimer((t) => false);
      setCountDown(0);
      setIsGenerating((t) => false);
      setHasGenerating(false);
      toast.error("Please Generate an Image", {
        icon: "👏",
        style: {
          borderRadius: "10px",
          background: "#333",
          color: "#fff",
        },
      });
      return;
    }

    // if (avatarImageUrlSelected == "") {
    setselectedAvatarURL(activeImage);
    // } else {
    // setselectedAvatarURL(avatarImageUrlSelected);
    // }


    // setChatHistory([]);
    const introChatHistory = []
    setCountDown(0);

    setIsGeneratingImage((t) => true);

    // setHasGeneratingImage((t) => false);
    setRunTimer((t) => true);
    // const newChatHistory = [
    //   ...chatHistory,
    //   {
    //     text: currentMessage,
    //     sender: "user",
    //     profile: userData?.profile_picture ?? "/images/profile.png",
    //     audioUrl: "",
    //     // videoUrl: '',
    //   },
    //   // { text: '', sender: "bot", profile: avatarImageUrlSelected },
    // ];
    // setChatHistory([
    //   // ...introChatHistory,
    //   {
    //     text: "say 'Hello how are you'",
    //     sender: "user",
    //     profile: userData?.profile_picture ?? "/images/profile.png",
    //     audioUrl: "",
    //     // videoUrl: '',
    //   },
    //   // { text: '', sender: "bot", profile: avatarImageUrlSelected },
    // ]);

    // console.log(convertMessages(chatHistory));

    // const botResponse = ChatBotBot.getResponse(currentMessage);
    var data = await postDataIdle(
      "https://xq3pl2oc187t2f-4000.proxy.runpod.net/create_idle",
      {
        img_url: activeImage,
        sessionuid: sessionuid,
        chatbot: location.state.name.replaceAll(' ', '')
      }
    );
    // console.log("DONE IDLE ANIMATION");
    // console.log(data);

    // setavatarVideoUrl("");
    // setavatarVideoUrl(data['response']);

    // setChatHistory([
    //     ...chatHistory,
    //     { text: currentMessage, sender: "user" },
    //     { text: data['text'], sender: "bot" },
    // ]);

    // setCurrentMessage("");

  };


  const sendMessageAudio = async () => {


    setIsAudio(true);
    setIsPlaying(false);
    // audioRef.current.pause();


    // const botResponse = ChatBotBot.getResponse(currentMessage);
    var data = await postData(
      "https://2ook38ir4ea9ub-3000.proxy.runpod.net/queue",
      {
        img_url: selectedAvatarURL,
        prompt: currentMessage,
        is_audio: true,
        dc: convertMessages(chatHistory),
        voice: selectedValue,
        language: chosenLanguage,
        yawScale: yawScale,
        headMovement: headMovement,
        pitchScale: pitchScale,
        rollScale: rollScale,
        inputPrompt: inputPrompt,
        superenhance: superenhance,
        answer: resultRef.current
      }
    );
    // setavatarVideoUrl("");
    // setavatarVideoUrl(data['response']);

    // setChatHistory([
    //     ...chatHistory,
    //     { text: currentMessage, sender: "user" },
    //     { text: data['text'], sender: "bot" },
    // ]);

    // setCurrentMessage("");
  };

  // const avatarVideoUrl = "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4";

  const onSelectImage = (image) => {
    setActiveImage(image);
    // setAvatarImageUrl(image);
  };
  const retry = () => {
    setChatHistory([]);
    // Add your retry logic here
  };

  const onHandleChangeSwitch = (e) => {
    setFaceOrAudioToggle(e.target.checked);
  };

  const onSetImageForPlaying = () => {
    setIsPlayingImage(!isPlayingImage);
    sendMessageHeadOnPlay();
  };
  const handleTabChange = (selectedKey) => {
    console.log('Selected tab:', selectedKey);
    // You can add more logic here based on the selected tab
  };

  const createSession = async () => {
    const myUuid = uuidv4();

    const docRef = doc(db, 'Sessions', (myUuid));
    await setDoc(docRef, {
      'uuid': myUuid,
      'language': chosenLanguage,
      'name': name,
      'input_image': selectedImage,
      // 'last_generated_vid' :
      // 'date_created': new Date(),
      // 'created_by': (userData?.name) ?? 'Unknown',
      // 'description': description,
      // 'expression_scale': headMovement,
      // 'id': (name).replace(/ /g, "-"),
      // 'inputImage': activeImage,
      // 'inputPrompt': inputPrompt,
      // 'language': selectedOption,
      // 'name': name,
      // 'pitchScale': pitchScale,
      // 'rollScale': rollScale,
      // 'yawScale': yawScale,
      // 'tokenized': false,
      // 'voice': selectedVoice,
      // 'numChatbot': querySnapshot.size,
      // 'generated_intro_vid': resultResponse["data"]["response"]
    });
  }
  const aisettings = {
    infinite: true,
    // autoplay: true,
    autoplaySpeed: 2500,
    arrows: true,
    dots: false,
    slidesToShow: 6,
    margin: 10,
    centerPadding: 20,
    useTransform: true,
    scroll: "smooth",
    responsive: [
      {
        breakpoint: 1430,
        settings: {
          slidesToShow: 4,
          // slidesToScroll: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 5,
          // slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          // slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 4,
          // slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          // slidesToScroll: 1,
        },
      },
    ],
  };

  // const textareaRef = useRef();

  const onHandleCurrentMessageChange = (event) => {
    // const inputHeight = event.target.scrollHeight > 50 ? textareaHeight + 25 : 50;
    setCurrentMessage(event.target.value)
    // setTextareaHeight(inputHeight);   
  }
  // const handleKeyUp = (event) => {
  //   // Calculate the scrollHeight of the textarea without the added content.
  //   console.log({ textareaRef })
  //     const textarea = textareaRef.current;

  //     textarea.style.height = '50px'; // Reset the height.
  //     const scrollHeight = textarea.scrollHeight;
  //     console.log({ scrollHeight })

  //     if (scrollHeight > textareaHeight) {
  //       textarea.style.height = `${textareaHeight + 25}px`; // Maintain the maximum height.
  //     } else if (scrollHeight < textareaHeight) {
  //       setTextareaHeight(scrollHeight - 25);          
  //     }
  // }

  const textAreaRef = useRef(null);
  const textAreaRefMobile = useRef(null);

  useAutosizeTextArea(textAreaRef.current, currentMessage);
  useAutosizeTextArea(textAreaRefMobile.current, currentMessage);

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);

  const onSelectFiles = (event) => {
    let images = [];

    for (let i = 0; i < event.target.files.length; i++)
    {
      images.push(URL.createObjectURL(event.target.files[i]));
    }

    setSelectedFiles([...selectedFiles, ...event.target.files]);
    setImagePreviews([...imagePreviews, ...images]);
  }
  const onRemoveSelectedImage = (index) => {
    let images = [...selectedFiles];
    let previews = [...imagePreviews]
    images.splice(index, 1)
    previews.splice(index, 1)
    setSelectedFiles(images)
    setImagePreviews(previews)
  };
  return (
    <div className="main-content App chat-app">
      <>
        {/* <Tabs
          defaultActiveKey="profile"
          id="justify-tab-example"
          className="mb-3"
          // justify
          onSelect={handleTabChange}
        >
          <Tab eventKey="home" title="Home">
            Tab content for Home
          </Tab>
          <Tab eventKey="profile" title="Profile">
            Tab content for Profile
          </Tab>
          <Tab eventKey="longer-tab" title="Loooonger Tab">
            Tab content for Loooonger Tab
          </Tab>
          <Tab eventKey="contact" title="Contact" disabled>
            Tab content for Contact
          </Tab>
        </Tabs> */}
        <div className="mobile-toggle-Switch toggle-Switch">
          {/* {console.log({ isThemeDark2132123: isThemeDark })} */}
          <span className={faceOrAudioToggle && "disable"}>
            <lord-icon
              src="https://cdn.lordicon.com/fdlndzao.json"
              trigger="loop"
              colors={isThemeDark ? "outline:#121331,primary:#b26836,secondary:#fff,tertiary:#4bb3fd,quaternary:#f9c9c0" : "outline:#121331,primary:#b26836,secondary:#000,tertiary:#4bb3fd,quaternary:#f9c9c0"}
            ></lord-icon>
            Face
          </span>
          <Form.Check
            type="switch"
            id="custom-switch"
            onChange={onHandleChangeSwitch}
          />
          <span className={!faceOrAudioToggle && "disable"}>
            <lord-icon
              src="https://cdn.lordicon.com/euoeggon.json"
              trigger="loop"
              colors={isThemeDark ? "outline:#fff" : "outline:#000"}
            ></lord-icon>{" "}
            Audio
          </span>
        </div>

        <Row className="chatbox-height">
          <Col lg={7}>
            <div className="input-container-clippath desktop-version">
              <div className="input-container">
                <div className="chatheader">
                  <Button variant="" className="Advanced-main-wrap text-white" onClick={handleShow}>
                    <i>
                      <lord-icon src="https://cdn.lordicon.com/exlyjeeh.json" trigger="hover" colors="outline:#131431,primary:#36e899" ></lord-icon>
                    </i>
                    <span>Advanced Settings</span>
                  </Button>
                  {isCreating ? <Button variant="" className="Advanced-main-wrap text-white" onClick={handleShow2}>
                    <i><lord-icon src="https://cdn.lordicon.com/gdbnaaef.json" trigger="hover" colors="outline:#121331,primary:#ffffff,secondary:#36e899"></lord-icon></i>
                    <span>Upload AI Companion</span>
                  </Button> : (<div></div>)}


                  {/* {isCreating ? (<div className="Advanced-main-wrap" onClick={handleShow2} style={{ 'margin-left': '10px' }}>
                    <p style={{ 'font-size': '13px' }}>Upload Chatbot</p>
                  </div>) : (<div></div>)} */}




                  <div className="toggle-Switch">
                    <span className={faceOrAudioToggle && "disable"}>
                      <lord-icon
                        src="https://cdn.lordicon.com/euoeggon.json"
                        trigger="loop"
                        colors={isThemeDark ? "outline:#fff" : "outline:#000"}
                      ></lord-icon>
                      Audio
                    </span>

                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      onChange={onHandleChangeSwitch}
                    />
                    <span className={!faceOrAudioToggle && "disable"}>
                      <lord-icon
                        src="https://cdn.lordicon.com/fdlndzao.json"
                        trigger="loop"
                        colors={isThemeDark ? "outline:#121331,primary:#b26836,secondary:#fff,tertiary:#4bb3fd,quaternary:#f9c9c0" : "outline:#121331,primary:#b26836,secondary:#000,tertiary:#4bb3fd,quaternary:#f9c9c0"}
                      ></lord-icon>
                      Face
                    </span>
                  </div>
                  {chatHistory.length > 0 &&
                    <OverlayTrigger
                      overlay={
                        <Tooltip placement="bottom">
                          Reset your chat
                        </Tooltip>
                      }
                    >
                      <Button variant="" className="Chat-reset" onClick={retry}>
                        <Icon icon="icon-park-outline:undo" />
                      </Button>
                    </OverlayTrigger>

                  }

                </div>
                <div className="chatfield" ref={chatFieldRef}>
                  {chatHistory.map((msg, i) => (
                    <p
                      key={i}
                      className={`chat-messagebox ${msg.sender === "system"
                        ? "message-end"
                        : "message-start"
                        }`}
                    >
                      <i>
                        <img style={{ width: "50px" }} src={msg.profile} />
                      </i>

                      {/* <LinearProgress /> */}


                      {msg.sender === "system" ? (
                        <div className="msgbox">

                          {msg.audioUrl !== "" && (
                            <div className="audio-player">
                              {/* <audio ref={videoRef} controls>
                                <source src={msg.audioUrl} type="video/mp4" />
                                Your browser does not support the video tag.
                              </audio> */}
                              <AudioPlayer autoPlay src={msg.audioUrl} />

                              <hr />
                            </div>
                          )}

                          <p>


                            {/* <WindupChildren> */}
                            {parse(msg.text)}


                            {/* <em>{"wild"}</em>
                            {"stuff with text!"} */}
                            {/* </WindupChildren> */}
                          </p>

                        </div>

                      ) : (
                        <div className="msgbox usermsgbox">
                          <p dangerouslySetInnerHTML={{ __html: msg.text }} />
                        </div>
                      )}
                    </p>
                  ))}
                  {isRunning && !isTyping ? (<p className={`chat-messagebox message-end`}>
                    <i><img style={{ width: '50px' }} src={selectedAvatarURL}></img></i>
                    <div class='msgbox'>
                      {/* <Typewriter words={resultt.split(' ')}></Typewriter> */}
                      <p>{parse(resultt)}</p>

                    </div>
                  </p>) : (<div></div>)}

                  {isTyping ? (
                    <div style={{ "text-align": "right" }}>
                      <div style={{ display: "inline-block" }}>
                        {" "}
                        <img
                          src={
                            "https://www.dropbox.com/s/syx8lrzq6juz0gu/Message-1s-38px.gif?dl=1"
                          }
                        ></img>
                      </div>
                      <i>
                        <img
                          src={selectedAvatarURL}
                          style={{
                            width: "50px",
                            "border-radius": "40px",
                            "margin-right": "16px",
                          }}
                        />
                      </i>{" "}
                    </div>
                  ) : null}

                </div>
                {chatHistory.length === 0 && <ul className="defalut-prompt">
                  <li>
                    <Link tp="#" onClick={() => onSendDirectMessage('What are your top 5 facts for travelling space in a swimsuit?')}>
                      <h6>What are your top 5 facts <span>for travelling space in a swimsuit</span> </h6>
                      <i><Icon icon="ic:round-send" /></i>
                    </Link>
                  </li>
                  <li>
                    <Link tp="#" onClick={() => onSendDirectMessage('Suggest some names for my cafe-by-day, bar-by-night business')}>
                      <h6>Suggest some names <span>for my cafe-by-day, bar-by-night business</span> </h6>
                      <i><Icon icon="ic:round-send" /></i>
                    </Link>
                  </li>
                  <li>
                    <Link tp="#" onClick={() => onSendDirectMessage('Compare marketing strategies for sunglasses for Gen Z and Millennials')}>
                      <h6>Compare marketing strategies <span>for sunglasses for Gen Z and Millennials</span> </h6>
                      <i><Icon icon="ic:round-send" /></i>
                    </Link>
                  </li>
                  <li>
                    <Link tp="#" onClick={() => onSendDirectMessage('Come up with concepts for a retro-style arcade game')}>
                      <h6>Come up with concepts <span>for a retro-style arcade game</span> </h6>
                      <i><Icon icon="ic:round-send" /></i>
                    </Link>
                  </li>
                </ul>}
                <div className="chat-input-box chatbox-mobile-wrap">
                  <div className="chat-input-boxmain">
                    <label Htmlfor="fileUploadtext" className="fileUploadtext">
                      <input type="file" id="fileUploadtext" onChange={onSelectFiles} multiple />
                      <span><Icon icon="fluent:image-add-24-filled" /></span>
                    </label>
                    <div className="textareaDesgin">

                      <textarea
                        placeholder="Send your message"
                        // rows={4}
                        ref={textAreaRef}
                        // style={{height: textareaHeight > 100 ? 'auto' : `${textareaHeight}px`}}
                        value={currentMessage}
                        onChange={(e) => onHandleCurrentMessageChange(e)}
                        disabled={isListening}
                        // onKeyDown={(e) => handleKeyUp(e)}
                        onKeyPress={(e) => {
                          // handleKeyUp(e);                        
                          if (activeImage !== 'https://firebasestorage.googleapis.com/v0/b/orbofibluesky-7f04d.appspot.com/o/dark-img-upload.png?alt=media&token=474bcca1-fd06-44d8-8c2e-2898651dbb60&_gl=1*11hdrzi*_ga*NDI5MDg0OTczLjE2ODI0Njk1NzQ.*_ga_CW55HF8NVT*MTY5NjI1MjY2MS41LjEuMTY5NjI1MjY4Ni4zNS4wLjA' && activeImage !== "https://firebasestorage.googleapis.com/v0/b/orbofibluesky-7f04d.appspot.com/o/chat-default-image.png?alt=media&token=936b0f65-f711-4153-a1d9-0f1250ad1411")
                          {
                            if (e.key === "Enter" && !faceOrAudioToggle)
                            {
                              e.preventDefault();
                              setIsTyping(true);
                              streamTextGeneration();
                            }
                            else if (e.key === "Enter" && !faceOrAudioToggle == false)
                            {
                              e.preventDefault();
                              setIsTyping(true);
                              streamTextGeneration();
                            }
                          }

                        }}
                      />
                      <div className="textareaImgWrap">
                        {imagePreviews && imagePreviews.map((img, index) => (
                          <div className="textareaImg">
                            <Image src={img} key={index} alt="" />
                            <Button className="btn-close-img" variant="" type="button" onClick={() => onRemoveSelectedImage(index)}><Icon icon="ic:round-close" /></Button>
                          </div>
                        ))}
                      </div>
                    </div>
                    <Button variant="" className="record-btn" onClick={startListening}>{isListening ? <Icon icon="ic:round-pause" /> : <Icon icon="ic:outline-mic" />}</Button>
                  </div>
                  <Button variant="" className=" btn-mobile-reset" onClick={retry}>
                    <Icon icon="icon-park:redo" />
                  </Button>
                  {/* {!currentMessage ? (
                    <> */}

                  <Button
                    variant=""
                    className="chatbot-send-button btn-message"
                    onClick={() => { setIsTyping(true); streamTextGeneration(); }}
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <lord-icon
                        src="https://cdn.lordicon.com/wfmfwkbb.json"
                        trigger="loop"
                        colors="primary:#eee"
                      ></lord-icon>
                    ) : (
                      <span>
                        <Icon icon="ic:round-send" />
                      </span>
                    )}
                  </Button>
                  {console.log({ isLoading, generatedImages, activeImage })}
                  {/* </>
                  ) :
                    !faceOrAudioToggle ? (
                      <Button
                        variant=""
                        type="submit"
                        className="chatbot-send-button btn-gradient btn-message"
                        onClick={() => { setIsTyping(true); streamTextGeneration(); }}
                        disabled={isLoading || activeImage === ""}
                      >
                        {isLoading ? (
                          <lord-icon
                            src="https://cdn.lordicon.com/wfmfwkbb.json"
                            trigger="loop"
                            colors="primary:#eee"
                          ></lord-icon>
                        ) : (
                          <span>
                            <Icon icon="ic:round-send" />
                          </span>
                        )}
                      </Button>
                    ) : (
                      <Button
                        variant=""
                        className="chatbot-send-button btn-gradient btn-message"
                        onClick={() => { setIsTyping(true); streamTextGeneration(); }}
                        disabled={isLoading || generatedImages.length === 0}
                      >
                        {isLoading ? (
                          <lord-icon
                            src="https://cdn.lordicon.com/wfmfwkbb.json"
                            trigger="loop"
                            colors="primary:#eee"
                          ></lord-icon>
                        ) : (
                          <span>
                            <Icon icon="ic:round-send" />
                          </span>
                        )}
                      </Button>
                    )} */}

                </div>
              </div>
            </div>
            {/* {resultt} */}
            <div className="input-container-clippath mobile-version">
              <div className="chatfield">

                {chatHistory.map((msg, i) => (
                  <p
                    key={i}
                    className={`chat-messagebox ${msg.sender === "system"
                      ? "message-end"
                      : "message-start"
                      }`}
                  >
                    <i>
                      <img style={{ width: "50px" }} src={msg.profile} />
                    </i>
                    {msg.sender === "system" ? (
                      <div className="msgbox">
                        {audioUrl !== "" && (
                          <div className="audio-player">
                            {/* <audio ref={videoRef} controls>
                                <source src={msg.audioUrl} type="video/mp4" />
                                Your browser does not support the video tag.
                              </audio> */}
                            <AudioPlayer src={audioUrl} />
                            <hr />
                          </div>
                        )}

                        <p>
                          {/* <WindupChildren> */}
                          {parse(msg.text)}
                          {/* {resultt} */}

                          {/* <em>{"wild"}</em>
                            {"stuff with text!"} */}
                          {/* </WindupChildren> */}
                        </p>
                      </div>
                    ) : (
                      <div className="msgbox usermsgbox" style={{ 'padding': '10px' }}>
                        <p dangerouslySetInnerHTML={{ __html: msg.text }} />
                      </div>
                    )}
                  </p>
                ))}
                {isRunning && !isTyping ? (<p className={`chat-messagebox message-end`}>
                  <i><img style={{ width: '50px' }} src={selectedAvatarURL}></img></i>
                  <div class='msgbox'>
                    <p>{parse(resultt)}</p>

                  </div>
                </p>) : (<div></div>)}

                {isTyping ? (
                  <div style={{ "text-align": "right" }}>
                    <div style={{ display: "inline-block" }}>
                      {" "}
                      <img
                        src={
                          "https://www.dropbox.com/s/syx8lrzq6juz0gu/Message-1s-38px.gif?dl=1"
                        }
                      ></img>
                    </div>
                    <i>
                      <img
                        src={selectedAvatarURL}
                        style={{
                          width: "50px",
                          "border-radius": "40px",
                          "margin-right": "16px",
                        }}
                      />
                    </i>{" "}
                  </div>
                ) : null}
              </div>
              <div className="chat-input-box chatbox-mobile-wrap">
                <div className="mobile-flex-chatbox">
                  <label Htmlfor="fileUploadtext" className="fileUploadtext">
                    <input type="file" id="fileUploadtext" onChange={onSelectFiles} multiple />
                    <span><Icon icon="fluent:image-add-24-filled" /></span>
                  </label>
                  <div className="textareaDesgin">

                    <textarea
                      placeholder="Send your message"
                      // rows={4}
                      ref={textAreaRefMobile}
                      // style={{height: textareaHeight > 100 ? 'auto' : `${textareaHeight}px`}}
                      value={currentMessage}
                      onChange={(e) => onHandleCurrentMessageChange(e)}
                      disabled={isListening}
                      // onKeyDown={(e) => handleKeyUp(e)}
                      onKeyPress={(e) => {
                        // handleKeyUp(e);                        
                        if (activeImage !== 'https://firebasestorage.googleapis.com/v0/b/orbofibluesky-7f04d.appspot.com/o/dark-img-upload.png?alt=media&token=474bcca1-fd06-44d8-8c2e-2898651dbb60&_gl=1*11hdrzi*_ga*NDI5MDg0OTczLjE2ODI0Njk1NzQ.*_ga_CW55HF8NVT*MTY5NjI1MjY2MS41LjEuMTY5NjI1MjY4Ni4zNS4wLjA' && activeImage !== "https://firebasestorage.googleapis.com/v0/b/orbofibluesky-7f04d.appspot.com/o/chat-default-image.png?alt=media&token=936b0f65-f711-4153-a1d9-0f1250ad1411")
                        {
                          if (e.key === "Enter" && !faceOrAudioToggle)
                          {
                            e.preventDefault()
                            setIsTyping(true);
                            streamTextGeneration();
                          }
                          else if (e.key === "Enter" && !faceOrAudioToggle == false)
                          {
                            e.preventDefault()
                            setIsTyping(true);
                            streamTextGeneration();
                          }
                        }

                      }}
                    />
                    <div className="textareaImgWrap">
                      {imagePreviews && imagePreviews.map((img, index) => (
                        <div className="textareaImg">
                          <Image src={img} key={index} alt="" />
                          <Button className="btn-close-img" variant="" type="button" onClick={() => onRemoveSelectedImage(index)}><Icon icon="ic:round-close" /></Button>
                        </div>
                      ))}
                    </div>
                  </div>
                  <Button variant="" className="Advanced-main-wrap mobile-send-setting" onClick={handleShow}>
                    <i> <lord-icon src="https://cdn.lordicon.com/exlyjeeh.json" trigger="hover" colors="outline:#131431,primary:#36e899" ></lord-icon> </i>
                  </Button>
                  {isCreating ? <Button variant="" className="Advanced-main-wrap mobile-send-setting" onClick={handleShow2}>
                    <i><lord-icon src="https://cdn.lordicon.com/gdbnaaef.json" trigger="hover" colors="outline:#121331,primary:#ffffff,secondary:#36e899"></lord-icon></i>
                  </Button> : (<div></div>)}
                </div>
                {!currentMessage ? (
                  <Button variant="" className="mobile-btn record-btn" onClick={startListening}>{isListening ? <Icon icon="ic:round-pause" /> : <Icon icon="ic:outline-mic" />}</Button>
                ) : isListening ? (
                  <Button variant="" className="mobile-btn record-btn" onClick={startListening}>{isListening ? <Icon icon="ic:round-pause" /> : <Icon icon="ic:outline-mic" />}</Button>
                ) :
                  !faceOrAudioToggle ? (
                    <Button
                      variant=""
                      type="submit"
                      className="chatbot-send-button btn-message mobile-btn"
                      onClick={streamTextGeneration}
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <lord-icon
                          src="https://cdn.lordicon.com/wfmfwkbb.json"
                          trigger="loop"
                          colors="primary:#eee"
                        ></lord-icon>
                      ) : (
                        <span>
                          <Icon icon="ic:round-send" />
                        </span>
                      )}
                    </Button>
                  ) : (
                    <Button
                      variant=""
                      className="chatbot-send-button mobile-btn btn-message"
                      onClick={streamTextGeneration}
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <lord-icon
                          src="https://cdn.lordicon.com/wfmfwkbb.json"
                          trigger="loop"
                          colors="primary:#eee"
                        ></lord-icon>
                      ) : (
                        <span>
                          <Icon icon="ic:round-send" />
                        </span>
                      )}
                    </Button>
                  )}
              </div>
            </div>
          </Col>

          <Col lg={5}>
            {hasGenerated ? (
              <div className="AiAvtarCard">
                <div className="AiAvtarImgCard">

                  {isVideo ? (
                    <div className="AiAvtarvideoCard">
                      <div className="AiAvtarvideoCardround">

                        <div style={{ borderRadius: '15px', marginBottom: '15px' }}>
                          <div class="video-container">
                            <img src={activeImage}></img>
                            <video ref={videoRef2} ></video>
                            <video ref={videoRef3} ></video>
                          </div>
                        </div>
                        {isProgressing ? (<div style={{ 'width': '100%', 'paddingBottom': '12px' }}>
                          <BorderLinearProgress />
                        </div>) : null}


                        <div className="AiAvtarvideoCardinfo">
                          <span><Image src={activeImage} /></span>
                          <div className="AiAvtarvideoCardinfos">
                            <h5>{chatbotName}</h5>
                            <h6> <i><Icon icon="mdi:user-circle" color="white" /> </i>{createdBy}</h6>
                            <p>{descriptionChatbot}</p>
                          </div>
                        </div>
                      </div>

                      {/* <Link to="/CreateChatbot"
                        className="chatbot-send-button btn-gradient mb-btn-send"
                        style={{ 'margin': '0 auto', 'width': '100%', 'textAlign': 'center' }}
                      >
                        Recreate Chatbot
                      </Link> */}
                    </div>
                  ) : (
                    <div className="AiAvtarvideoCard">
                      <Image src={activeImage} />
                      {/* <video ref={videoRef} controls>
                          <source src={avatarVideoUrl} type="video/mp4" />
                          Your browser does not support the video tag.
                        </video> */}
                      <Link to="/CreateChatbot"
                        className="chatbot-send-button btn-gradient mb-btn-send"
                        style={{ 'margin': '0 auto', 'width': '100%', 'textAlign': 'center' }}
                      // onClick={() => {
                      //   setIsPlayingImage(false);
                      //   setHasGenerating(false);
                      //   if (location.state.voice == "Danny Trejo")
                      //   {
                      //     console.log("DANNY");
                      //     setMessage("professional headshot of danny trejo as a cowboy");
                      //   }

                      // }}
                      >
                        Recreate Chatbot
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            ) : avatarImageUrlSelected == "" ? (
              <div className="AiAvtarCard">
                <div className="AiAvtarImgCard">
                  {/* {console.log({ generatedImages })} */}
                  <div className="AiAvtarvideoCardinfo">
                    <span><Image src={activeImage} /></span>
                    <div className="AiAvtarvideoCardinfos">
                      <h5>{chatbotName}</h5>
                      <h6> <i><Icon icon="mdi:user-circle" color="white" /> </i>{createdBy}</h6>
                      <p>{descriptionChatbot}</p>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="AiAvtarvideoCardinfo">
                <span><Image src={activeImage} /></span>
                <div className="AiAvtarvideoCardinfos">
                  <h5>{chatbotName}</h5>
                  <h6> <i><Icon icon="mdi:user-circle" color="white" /> </i>{createdBy}</h6>
                  <p>{descriptionChatbot}</p>
                </div>
              </div>
            )}
          </Col>

        </Row>
      </>
      {/* )} */}
      <Modal show={isLanguageModal} onHide={handleCloseLanguageModal} centered size="lg" className="FactoryListPopup advancePopup max-50">
        <Modal.Body>
          <Link
            to="#"
            className="CloseBtn"
            onClick={handleCloseLanguageModal}
          >
            <Icon icon="ion:close-circle" color="white" />
          </Link>
          <h5 className="factoryListTitle">Choose Language Parameters</h5>
          <p className="FactorySettingText">Customize your AI assistant in whatever way you want!</p>
          <hr />
          <h6 className="label-title">Language  Parameters</h6>
          <div className="Voice-main-wrap z-3">
            <Form.Label>Language  : </Form.Label>
            <div className="Voices-Wrap">
              <Select
                placeholder="Select Option"
                value={selectedOption}
                className="LanguageSelect"
                options={languages}
                onChange={handleLanguageChange}
                styles={customStyles2}
                getOptionLabel={(e) => (
                  <div className="d-flex align-items-center">
                    {/* {e.icon} */}
                    <span className="ms-2" style={{ fontSize: 13 }}>{e.value}</span>
                  </div>
                )}
              />
            </div>
          </div>

        </Modal.Body>
        <hr />
        <div className="btn-flex-modal">
          <Button variant="" className="btn-border-white" onClick={handleClick}>Cancel</Button>
          <Button variant="" className="btn-white" onClick={handleClick}>Save</Button>
        </div>
      </Modal>
      <Modal show={isChatModal} onHide={handleCloseChatModal} centered size="lg" className="FactoryListPopup advancePopup max-50">
        <Modal.Body>
          <Link
            to="#"
            className="CloseBtn"
            onClick={handleCloseChatModal}
          >
            <Icon icon="ion:close-circle" color="white" />
          </Link>
          <h5 className="factoryListTitle">Choose  Model Parameters</h5>
          <p className="FactorySettingText">Customize your AI assistant in whatever way you want!</p>
          <hr />
          <h6 className="label-title">Model  Parameters</h6>
          <div className="Voice-main-wrap z-1">
            <Form.Label>Model  : </Form.Label>
            <div className="Voices-Wrap">
              <Select
                placeholder="Select Option"
                value={selectedModelOption}
                className="LanguageSelect"
                options={models}
                onChange={handleModelChange}
                styles={customStyles2}
                getOptionLabel={(e) => (
                  <div className="d-flex align-items-center">
                    <span className="ms-2" style={{ fontSize: 13 }}>{e.text}</span>
                  </div>
                )}
              />
            </div>
          </div>

        </Modal.Body>
        <hr />
        <div className="btn-flex-modal">
          <Button variant="" className="btn-border-white" onClick={handleClick}>Cancel</Button>
          <Button variant="" className="btn-white" onClick={handleClick}>Save</Button>
        </div>
      </Modal>
      <Modal show={isVoiceModal} onHide={handleCloseVoiceModal} centered size="lg" className="FactoryListPopup advancePopup max-50">
        <Modal.Body>
          <Link
            to="#"
            className="CloseBtn"
            onClick={handleCloseVoiceModal}
          >
            <Icon icon="ion:close-circle" color="white" />
          </Link>
          <h5 className="factoryListTitle">Choose Voice Parameters</h5>
          <p className="FactorySettingText">Customize your AI assistant in whatever way you want!</p>
          <hr />
          <h6 className="label-title">Voice Parameters</h6>
          <div className="Voice-main-wrap z-2">
            <Form.Label>Voice :</Form.Label>
            <div className="Voices-Wrap">
              <Select
                placeholder="Select Option"
                value={selectedVoiceForSelectBox}
                className="LanguageSelect userSelect"
                options={voices}
                onChange={handleCategoryChange}
                styles={customStyles}
                // menuPortalTarget={document.body}
                // menuPosition={'fixed'}
                getOptionLabel={(e) => (
                  <div><span style={{ marginLeft: 10, fontSize: 13 }}>{e.name}</span></div>
                )}
              />
            </div>
          </div>

        </Modal.Body>
        <hr />
        <div className="btn-flex-modal">
          <Button variant="" className="btn-border-white" onClick={handleClick}>Cancel</Button>
          <Button variant="" className="btn-white" onClick={handleClick}>Save</Button>
        </div>
      </Modal>
      <Modal show={show} onHide={handleClose} centered size="lg" className="FactoryListPopup advancePopup">
        <Modal.Body>
          <Link
            to="#"
            className="CloseBtn"
            onClick={handleClose}
          >
            <Icon icon="ion:close-circle" color="white" />
          </Link>
          <h5 className="factoryListTitle">Choose Parameters</h5>
          <p className="FactorySettingText">Customize your AI assistant in whatever way you want!</p>
          <hr />
          <h6 className="label-title">Voice & Chat Parameters</h6>
          <div className="options-flex">
            <div className="Voice-main-wrap z-3">
              <Form.Label>Language  : </Form.Label>
              <div className="Voices-Wrap">
                <Select
                  placeholder="Select Option"
                  value={selectedOption}
                  className="LanguageSelect"
                  options={languages}
                  onChange={handleLanguageChange}
                  styles={customStyles2}
                  getOptionLabel={(e) => (
                    <div className="d-flex align-items-center">
                      {/* {e.icon} */}
                      <span className="ms-2" style={{ fontSize: 13 }}>{e.value}</span>
                    </div>
                  )}
                />
              </div>
            </div>
            <div className="Voice-main-wrap z-2">
              <Form.Label>Voice :</Form.Label>
              <div className="Voices-Wrap">
                <Select
                  placeholder="Select Option"
                  value={selectedVoiceForSelectBox}
                  className="LanguageSelect userSelect"
                  options={voices}
                  onChange={handleCategoryChange}
                  styles={customStyles}
                  // menuPortalTarget={document.body}
                  // menuPosition={'fixed'}
                  getOptionLabel={(e) => (
                    <div><span style={{ marginLeft: 10, fontSize: 13 }}>{e.name}</span></div>
                  )}
                />
              </div>
            </div>

            <div className="Voice-main-wrap z-1">
              <Form.Label>Model  : </Form.Label>
              <div className="Voices-Wrap">
                <Select
                  placeholder="Select Option"
                  value={selectedModelOption}
                  className="LanguageSelect"
                  options={models}
                  onChange={handleModelChange}
                  styles={customStyles2}
                  getOptionLabel={(e) => (
                    <div className="d-flex align-items-center">
                      <span className="ms-2" style={{ fontSize: 13 }}>{e.text}</span>
                    </div>
                  )}
                />
              </div>
            </div>
          </div>
          <hr />
          <div className="FactorySettingTextbox">
            <h6 className="label-title">AI Prompt Tuner</h6>
            <textarea id="description" placeholder="Type here..." value={inputPrompt}
              onChange={handleInputPromptChange} />
          </div>
          <div>
            {/* Step 3 and 5: Create an input element of type checkbox and bind the state variable to the checked attribute */}
            <Form.Check // prettier-ignore
              type="switch"
              name="superenhance"
              checked={superenhance}
              onChange={handleCheckboxChange}
              id="Superenhance"
              label="Superenhance"
            />
          </div>
          <hr />
          <h6 className="label-title">Talking Head Parameters</h6>

          <div className="TalkingWrap">
            <div className="Talking50">
              <h6>Expression Scale ({headMovement})</h6>
              <Slider
                min={1}
                max={10}
                defaultValue={headMovement}
                onChange={(e) => setHeadMovement(e)}
              />
              <div className="DropProgressWrapInfo">
                <p>Low Expression</p>
                <p>High Expression</p>
              </div>
            </div>
            <div className="Talking50">
              <h6>Yaw ({yawScale})</h6>
              <Slider
                min={0}
                max={20}
                defaultValue={yawScale}
                onChange={(e) => setYaw(e)}
              />
              <div className="DropProgressWrapInfo">
                <p>No Yaw Change</p>
                <p>High Yaw Change</p>
              </div>
            </div>
            <div className="Talking50">
              <h6>Pitch ({pitchScale})</h6>
              <Slider
                min={0}
                max={20}
                defaultValue={pitchScale}
                onChange={(e) => setPitchScale(e)}
              />
              <div className="DropProgressWrapInfo">
                <p>No Pitch Change</p>
                <p>High Pitch Change</p>
              </div>
            </div>
            <div className="Talking50">
              <h6>Roll ({rollScale})</h6>
              <Slider
                min={0}
                max={20}
                defaultValue={rollScale}
                onChange={(e) => setRollScale(e)}
              />
              <div className="DropProgressWrapInfo">
                <p>No Roll Change</p>
                <p>High Roll Change</p>
              </div>
            </div>
          </div>

        </Modal.Body>
        <hr />
        <div className="btn-flex-modal">
          <Button variant="" className="btn-border-white" onClick={handleClick}>Cancel</Button>
          <Button variant="" className="btn-white" onClick={handleClick}>Save</Button>
        </div>
      </Modal>
      <Modal show={show2} onHide={handleClose2} centered size="lg" className="FactoryListPopup advancePopup">
        <Modal.Header >
          <Modal.Title className="center-title" style={{ 'font-weight': 'bold' }}>Upload AI Companion</Modal.Title>
          <button type="button" className="btn-close btn-close-white" aria-label="Close" onClick={handleClose2}></button>

        </Modal.Header>
        {isIntroLoading ? (
          <Modal.Body>



            <div className="options-flex" >
              {/* <img
                                  className=""
                                  src={selectedAvatarURL}
                                  alt="Avatar"
                                /> */}
              <div className="progressClass" style={{ 'textAlign': 'center', 'marginRight': 'auto', 'marginLeft': 'auto', 'paddingTop': '22px', 'paddingBottom': '10px' }}>
                <CircularProgressbarWithChildren
                  styles={{
                    path: { stroke: `#36e899` },
                    trail: { stroke: "#ffffff14" },
                  }}
                  className="ProgressMainInfo"
                  value={countDown}
                >
                  <div className="ProgressInfo">
                    <img
                      src="/images/big-logo-icon.png"
                      alt="doge"
                    />
                    <strong>{countDown}%</strong>
                  </div>
                </CircularProgressbarWithChildren>
              </div>
            </div>



          </Modal.Body>
        ) : (
          <Modal.Body>
            <h6 className="label-title">Voice & Chat Parameters</h6>
            <div className="options-flex">
              <div className="Voice-main-wrap z-3">
                <Form.Label>Language : </Form.Label>
                <div className="Voices-Wrap">
                  <Select
                    placeholder="Select Option"
                    value={selectedOption}
                    className="LanguageSelect"
                    options={languages}
                    onChange={handleLanguageChange}
                    styles={customStyles2}
                    getOptionLabel={(e) => (
                      <div className="d-flex align-items-center">
                        {/* {e.icon} */}
                        <span className="ms-2">{e.value}</span>
                      </div>
                    )}
                  />
                </div>
              </div>
              <div className="Voice-main-wrap z-2">
                <Form.Label>Voice :</Form.Label>
                <div className="Voices-Wrap">
                  <Select
                    placeholder="Select Option"
                    value={selectedVoiceForSelectBox}
                    className="LanguageSelect userSelect"
                    options={voices}
                    onChange={handleCategoryChange}
                    styles={customStyles}
                    // menuPortalTarget={document.body}
                    // menuPosition={'fixed'}
                    getOptionLabel={(e) => (
                      <div><span style={{ marginLeft: 10 }}>{e.name}</span></div>
                    )}
                  />
                </div>
              </div>

              <div className="Voice-main-wrap z-1">
                <Form.Label>Model  : </Form.Label>
                <div className="Voices-Wrap">
                  <Select
                    placeholder="Select Option"

                    value={selectedModelOption}
                    className="LanguageSelect"
                    options={models}
                    onChange={handleModelChange}
                    styles={customStyles2}
                    getOptionLabel={(e) => (
                      <div className="d-flex align-items-center">
                        <span className="ms-2">{e.text}</span>
                      </div>
                    )}
                  />
                </div>
              </div>
            </div>
            <hr />
            <div className="FactorySettingTextbox">
              <h6 className="label-title">AI Prompt Tuner</h6>
              <textarea id="description" placeholder="Type here..." value={inputPrompt}
                onChange={handleInputPromptChange} />
            </div>
            <hr />
            <h6 className="label-title">Talking Head Parameters</h6>
            <div className="TalkingWrap">
              <div className="Talking50">
                <h6>Expression Scale ({headMovement})</h6>
                <Slider
                  min={1}
                  max={10}
                  defaultValue={headMovement}
                  onChange={(e) => setHeadMovement(e)}
                />
                <div className="DropProgressWrapInfo">
                  <p>Low Expression</p>
                  <p>High Expression</p>
                </div>
              </div>
              <div className="Talking50">
                <h6>Yaw ({yawScale})</h6>
                <Slider
                  min={0}
                  max={20}
                  defaultValue={yawScale}
                  onChange={(e) => setYaw(e)}
                />
                <div className="DropProgressWrapInfo">
                  <p>No Yaw Change</p>
                  <p>High Yaw Change</p>
                </div>
              </div>
              <div className="Talking50">
                <h6>Pitch ({pitchScale})</h6>
                <Slider
                  min={0}
                  max={20}
                  defaultValue={pitchScale}
                  onChange={(e) => setPitchScale(e)}
                />
                <div className="DropProgressWrapInfo">
                  <p>No Pitch Change</p>
                  <p>High Pitch Change</p>
                </div>
              </div>
              <div className="Talking50">
                <h6>Roll ({rollScale})</h6>
                <Slider
                  min={0}
                  max={20}
                  defaultValue={rollScale}
                  onChange={(e) => setRollScale(e)}
                />
                <div className="DropProgressWrapInfo">
                  <p>No Roll Change</p>
                  <p>High Roll Change</p>
                </div>
              </div>
            </div>
            <hr />
            <div className="UploadPopup">
              <div className="profile-row-unique">
                <img
                  src={activeImage}
                  alt="profile-pic"
                  className="profile-row-picture"
                  style={{ borderRadius: activeImage === "https://firebasestorage.googleapis.com/v0/b/orbofibluesky-7f04d.appspot.com/o/chat-default-image.png?alt=media&token=936b0f65-f711-4153-a1d9-0f1250ad1411" ? '0px' : '12px' }}
                />
              </div>
              <div className="name-description-block">
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Name"
                  className="profile-row-textbox"
                />
                <textarea
                  type="text"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Description"
                  className="profile-row-textbox"
                />
                <Button
                  variant=""
                  className="chatbot-send-button btn-gradient "
                  onClick={uploadData}

                >
                  {
                    isUploading ? <span>
                      Uploading...
                    </span> : <span>
                      Upload
                    </span>
                  }
                </Button>
              </div>
            </div>
          </Modal.Body>
        )}
        <hr />
        <div className="btn-flex-modal">
          <Button variant="" className="btn-border-white" onClick={handleClick}>Cancel</Button>
          <Button variant="" className="btn-white" onClick={handleClick}>Save</Button>
        </div>
      </Modal>
      <div className={`overlay ${visible ? 'visible' : 'hidden'}`}>
        {/* <p>Loading Character...</p> */}
        {countDown2 >= 70 ? (
          <div style={{ 'height': '250px', 'width': '250px' }}>
            <Button
              variant=""
              className="chatbot-play-button mobile-btn btn-message"
              onClick={handlePlayVideo}
              disabled={isLoading}
            >
              <LordIcon
                src="https://cdn.lordicon.com/jcmfjvpk.json"
                trigger="hover"
                style={{ width: '250px', height: '250px' }}
              />
              <p>{windowWidth < 600 ? '' : 'Press Play to Start Chatbot'}</p>

            </Button>

          </div>

        ) : (
          <CircularProgressbarWithChildren
            styles={{
              path: { stroke: `#36e899` },
              trail: { stroke: "#ffffff14" },
            }}
            className="ProgressMainInfo"
            value={countDown2}
          >
            <div className="ProgressInfo">


              {countDown2 >= 70 ? (

                <Button
                  variant=""
                  className="chatbot-play-button"
                  onClick={handlePlayVideo}
                  disabled={isLoading}
                >
                  <LordIcon
                    src="https://cdn.lordicon.com/giasfzki.json"
                    trigger="hover"
                    style={{ width: '250px', height: '250px' }}
                  />
                  Press to Play

                </Button>
              ) : (<div style={{ 'textAlign': 'center' }}>
                <img src="/images/big-logo-icon.png" alt="doge" />
                <strong>{countDown2}%</strong>
              </div>)}


            </div>
          </CircularProgressbarWithChildren>
        )}

        {/* {countDown2 >= 100 && (
          <button onClick={handlePlayVideo}>Play Video</button>
        )} */}
      </div>
    </div >
  );
}

export default ChatBot;
